var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "skpfull_wrap", attrs: { id: "wrap" } }, [
    _c("div", { staticClass: "main-inner", attrs: { role: "main" } }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "title terms-button" }, [
          _c("h1", { attrs: { "ng-show": "!false" } }, [
            _vm._v(_vm._s(_vm.docTitle))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "one-terms" }, [
            _c("meta", {
              attrs: {
                "http-equiv": "Content-Type",
                content: "text/html; charset=utf-8"
              }
            }),
            _vm._v(" "),
            _c("title"),
            _vm._v(" "),
            _vm.languageCd == "en"
              ? _c("div", { staticClass: "terms-detail" }, [
                  _vm._v("\nEffective:  January, 1st 2021"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSamsung Electronics Co., Ltd. (Data Controller) (“"
                  ),
                  _c("b", [_vm._v("Samsung")]),
                  _vm._v(
                    '”) knows how important privacy is to its customers and their employees and partners, and we strive to be clear about how we collect, use, disclose, transfer and store your information. This Privacy Policy provides an overview of our information practices with respect to personal information collected through Service Knowledge Portal services with commercial customers (the "'
                  ),
                  _c("b", [_vm._v("Business Services")]),
                  _vm._v('").  '),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nThis Privacy Policy may be updated periodically to reflect changes in our personal information practices with respect to the Business Services or changes in the applicable law. We will indicate at the top of this Privacy Policy when it was most recently updated. If we update the Privacy Policy, we will let you know in advance about changes we consider to be material by placing a notice on the Business Services or by emailing you, where appropriate."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(0),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWe will collect various types of personal information in connection with the Business Services.  "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nFor example:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tWe will collect personal information that you provide, such as your name, e-mail address and contact details, and any communications you send or deliver to us;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tWe will collect information about services you or your employer have received and other information provided in connection with the Business Services for example, information collected in connection with the provision of repair services, including what product was assigned to the data subject, whether the system has approved it, the overall history and the date the system received a request from users ; and"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tWe also may receive personal information about you from your employer or service provider or from publicly and commercially available sources (as permitted by law), which we may combine with other information we receive from or about you (as permitted by law)."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(1),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWe may use information we collect for the following purposes: "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tto provide services that you (or your employer) requested and to register or authenticate you and your company;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tto respond to your questions or requests for information;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tto offer better services that take into account your company’s service record and other relevant information;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tsubject to your separate consent where required by applicable law, to inform you about new products and services;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tfor assessment and analysis of our market, customers, products, and services (including asking you for your opinions on our products and services and carrying out customer surveys);"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tto understand the way companies use the Business Services so that we can improve them and develop new products and services; "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tto provide maintenance services and to maintain a sufficient level of security on the Business Services;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tto protect the rights, property, or safety of Samsung, or any of our respective affiliates, business partners, employees or customers, for example, in legal proceedings, internal investigations and investigations by competent authorities;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\totherwise with your separate consent where required by applicable law or as described to at the time your information is collected."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSamsung processes personal information for the purposes described above. Samsung’s legal basis to process personal information includes processing: "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(i) So that we can keep our promises to you, such as providing you with the Business Service;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(ii) To promote our business interests (for example, to manage our relationship with you); and"
                  ),
                  _c("br"),
                  _vm._v("\n(iii) To comply with the law and legal processes;"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(2),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWe will disclose your information internally within our business, but only to those who need it to further provide Services or to help with your requests. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWe will also disclose your information to the following entities, only to the extent that this will be necessary to provide the Business Services:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n• Affiliates: Other Samsung Electronics Group companies which we control or own. "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n• Other parties when required by law or as necessary to protect our business: For example, it may be necessary by law, legal process, or court order from governmental authorities to disclose your information. They may also seek your information from us for the purposes of law enforcement, national security, anti-terrorism, or other issues that are related to public security."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n• Other parties in connection with corporate transactions: We may disclose your information to a third party as part of a merger or transfer, acquisition or sale, or in the event of a bankruptcy."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n• Other parties with your consent or at your direction: In addition to the disclosures described in this Privacy Policy, we may share information about you with third parties when you separately consent to or request such sharing."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(3),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWe take data protection seriously. We’ve put in place physical and technical safeguards to keep the information we collect secure. However, please note that although we take reasonable steps to protect your information, no website, Internet transmission, computer system, or wireless connection is completely secure.\n"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(4),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nYour use or participation in the Business Services may involve transfer, storage and processing of your information outside of your country of residence, consistent with this policy. Such countries include the Republic of Korea. Please note that the data protection and other laws of countries to which your information may be transferred might not be as comprehensive as those in your country. We will take appropriate measures, in compliance with applicable law, to ensure that your personal information remains protected. Such measures include the use of Standard Contractual Clauses to safeguard the transfer of data outside of the EEA. For more information on the safeguards we take to ensure the lawful transfer of your data to countries outside of the EU, or to obtain a copy of the contractual agreements in place, please contact us by the methods outlined in the "
                  ),
                  _c("b", [_vm._v("Contact Us")]),
                  _vm._v(" section of this Privacy Policy."),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(5),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nYour personal information belongs to you. You can ask us to provide details about what we’ve collected, and you can ask us to delete it or correct any inaccuracies. You can also ask us to restrict or limit processing, sharing, or transfer of your personal information, as well as to provide to you your personal information that we’ve collected so you can use it for your own purposes. To exercise your rights, please contact us by the methods outlined in the Contact Us section of this Privacy Policy. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nHowever, requesting the deletion of your personal information may also result in a loss of access to the Business Services. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nIf you request deletion of personal information, you acknowledge that you may not be able to access or use the Business Services and that residual personal information may continue to reside in Samsung's records and archives for some time in compliance with applicable law, but Samsung will not use that information for commercial purposes. You understand that, despite your request for deletion, Samsung reserves the right to keep your personal information, or a relevant part of it, in line with our data retention policy and applicable laws, if Samsung has suspended, limited, or terminated your access to the website for violating the Samsung Terms of Use or any other applicable Samsung policy or applicable law, when necessary to protect the rights, property, or safety of Samsung, or any of our respective affiliates, business partners, employees or customers."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(6),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWe won’t keep your personal information for longer than is necessary for the purpose for which it was collected. This means that information will be destroyed or erased from our systems when it’s no longer required."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWe take appropriate steps to ensure that we process and retain information about you based on the following logic:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n1. At least the duration for which the information is used to provide you with a service; "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n2. As required under law, a contract, or with regard to our statutory obligations;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n3. Only for as long as is necessary for the purpose for which it was collected, is processed, or longer if required under any contract, by applicable law, or for statistical purposes, subject to appropriate safeguards."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(7),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWe offer you certain choices in connection with the personal information we obtain about you.  "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "  \nThe Business Services may offer choices related to the collection, deletion and sharing of certain information related to the Business Services. If you decline to allow the Business Services to collect, store or share certain information, you may not be able to use all of the features available through the Business Services."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "  \nTo exercise your choices, please contact us as indicated in the "
                  ),
                  _c("b", [_vm._v("Contact Us")]),
                  _vm._v(" section of this Privacy Policy.  \n"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(8),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nYou can contact us to update your preferences, correct your information, submit a request, or ask us questions."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nYou can contact us at:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nData Controller"),
                  _c("br"),
                  _vm._v("\nSamsung Electronics Co., Ltd."),
                  _c("br"),
                  _vm._v("\n129, Samsung-ro, Yeongtong-gu,"),
                  _c("br"),
                  _vm._v("\nSuwon-si, Gyeonggi-do 16677, Republic of Korea"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSamsung Electronics has offices across Europe, so we can ensure that your request or query will be handled by the data protection team based in your region."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nThe easiest way to contact us is through our Privacy Support Page at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.samsung.com/request-desk",
                        target: "_blank"
                      }
                    },
                    [_vm._v("https://www.samsung.com/request-desk")]
                  ),
                  _vm._v(". "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nYou can also contact us at:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nEuropean Data Protection Officer"),
                  _c("br"),
                  _vm._v("\nSamsung Electronics (UK) Limited"),
                  _c("br"),
                  _vm._v(
                    "\nSamsung House, 1000 Hillswood Drive, Chertsey, Surrey KT16 0PS"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nYou can lodge a complaint with the relevant supervisory authority if you consider that our processing of your personal information infringes applicable law. Contact details for all EU supervisory authorities can be found at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080",
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v(
                        "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080"
                      )
                    ]
                  ),
                  _vm._v(".\n                        ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.languageCd == "fr"
              ? _c("div", { staticClass: "terms-detail" }, [
                  _vm._v("\nEntrée en vigueur : 1er janvier 2021"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nChez Samsung Electronics Co., Ltd. (Responsable du Traitement) (« "
                  ),
                  _c("b", [_vm._v("Samsung")]),
                  _vm._v(
                    " ») nous mesurons l’importance de la protection de la vie privée pour nos clients, employés et partenaires, et nous nous efforçons d’apporter une information claire sur la manière dont nous collectons, utilisons, divulguons, transférons et stockons vos informations. La présente Politique de Confidentialité a vocation à vous informer quant aux traitements de vos informations à caractère personnel dans le cadre de votre utilisation des services disponibles sur le Portail Samsung Documentation Services dédiés à nos clients professionnels (les « "
                  ),
                  _c("b", [_vm._v("Services")]),
                  _vm._v("»). "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nLa présente Politique de Confidentialité peut être mise à jour périodiquement afin de refléter les changements apportés à nos pratiques en matière de traitements des informations à caractère personnel relatives aux Services aux Entreprises ou encore les modifications de la loi applicable. Nous indiquerons en tête de la présente Politique de Confidentialité la date de sa dernière mise à jour. En cas de mise à jour, nous vous informerons à l'avance des changements que nous considérons comme importants en plaçant un avis sur la page dédiée aux Services ou en vous envoyant un courriel.\n"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(9),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNous recueillons plusieurs types d’informations à caractère personnel en lien avec les Services : "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tNous recueillons les informations à caractère personnel que vous fournissez, telles que votre nom, votre adresse e-mail et vos coordonnées, ainsi que toute information que vous nous communiquez ;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tNous recueillons des informations sur les prestations, services ou informations que vous ou votre société avez reçu ainsi que les informations fournies dans le cadre des Services, par exemple, les informations recueillies dans le cadre de la demande d’information et/ou des prestations de réparation (produit concerné, si la demande a été approuvée, date de la demande, personne à l’origine de la demande); et"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tNous pouvons également collecter des informations à caractère personnel vous concernant de la part de votre employeur ou de votre prestataire de services ou bien encore provenant de sources publiques autorisées, que nous pouvons combiner avec d'autres informations que nous recevons de votre part ou à votre sujet (comme la loi nous y autorise)."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(10),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNous pouvons utiliser les informations que nous recueillons aux fins suivantes : "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tfournir des services que vous (ou votre employeur) avez demandés afin de créer votre compte ou de vous authentifier, vous ou votre société ;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\trépondre à vos questions ou demandes de renseignements ;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\toffrir de meilleurs services avec le type d’informations qui sont utiles à votre entreprise ;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tvous tenir informés des nouveaux produits et services (avec votre consentement séparé si cela est prescrit par la loi locale applicable);"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tpour l'évaluation et l'analyse du marché, de nos clients, de nos produits et services (y compris pour vous demander votre avis sur nos produits et services, à travers par exemple des enquêtes de satisfaction) ;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tcomprendre la manière dont les entreprises utilisent les Services afin que nous puissions les améliorer et développer de nouveaux produits et services ; "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tfournir des prestations de maintenance afin de garantir le niveau de sécurité des Services ;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tprotéger les droits, les biens ou la sécurité de Samsung, ou de l'un(e) quelconque de nos sociétés affiliées, partenaires commerciaux, employés ou clients, par exemple, dans le cadre de procédures judiciaires, d'enquêtes internes et d'enquêtes menées par les autorités compétentes, ou dans le cadre de la lutte contre la fraude ;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tde toute autre manière, conformément à l’information qui vous sera fournie au moment de la collecte des données, et le cas échéant, sous réserve de votre consentement préalable lorsque celui-ci est exigé par la loi locale."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSamsung traite les informations à caractère personnel pour les finalités définies ci-dessus. Les bases légales d ces traitements sont les suivantes : "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(i) l’exécution du contrat, à savoir la fourniture du Service demandé;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(ii) notre intérêt légitime (par exemple, pour communiquer avec vous dans le cadre de la relation clients et ainsi répondre à vos questions ou faire des enquêtes de satisfaction) ; et"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(iii) le respect de nos obligations légales et règlementaires;"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(11),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVos informations peuvent être partagées au sein de Samsung, uniquement aux personnes qui en ont besoin pour fournir les Services ou pour répondre à vos demandes. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNous partageons également vos informations aux entités suivantes, uniquement dans la mesure où cela est nécessaire pour fournir les Services :"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n• Sociétés Affiliées : Autres sociétés du Groupe Samsung Electronics que nous contrôlons ou possédons. "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n• Personnes tierces lorsque la loi l'exige ou si nécessaire pour protéger nos activités. Par exemple, il peut s'avérer nécessaire en vertu de la loi, d'une procédure judiciaire ou administrative de partager certaines de vos informations. Les autorités peuvent également nous demander certaines de vos informations dans le cadre de la loi, pour des raisons de sécurité nationale, de lutte contre le terrorisme ou de sécurité publique."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n• Personnes tierces dans le cadre d'opérations d’achat ou de rachat d'entreprise : nous pouvons divulguer vos informations, lorsque cela est nécessaire, à un tiers dans le cadre d'une fusion ou d'un transfert, d'une acquisition ou d'une vente, ou en cas de faillite."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n• Personnes tierces avec votre consentement ou à votre demande : en plus des partages décrits dans la présente Politique de Confidentialité, nous pouvons partager des informations vous concernant avec des tiers lorsque vous y consentez de façon séparé ou à votre demande expresse."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(12),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNous prenons au sérieux la protection des données. Nous avons mis en place des mesures de protection physiques et techniques afin de protéger les informations que nous recueillons. Toutefois, veuillez noter que, bien que nous prenions des mesures raisonnables pour protéger vos informations, aucun(e) site internet, transmission Internet, système informatique ou connexion sans fil n'est entièrement sécurisé(e).\n"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(13),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVotre utilisation ou votre participation aux Services peut impliquer le transfert, le stockage et le traitement de vos informations en dehors de votre pays de résidence. Ces pays incluent la République de Corée (Corée du Sud). Il faut savoir que les lois sur la protection des données, et les autres lois des pays vers lesquels vos données peuvent être transférées, peuvent ne pas être aussi complètes que celles de votre pays. Nous prendrons les mesures appropriées, conformément à la loi applicable, pour assurer la protection de vos informations à caractère personnel. Ces mesures comprennent l'utilisation de Clauses contractuelles types visant à protéger le transfert de données hors de l'EEE. Pour plus d'informations sur les mesures de protection que nous appliquons afin de garantir le transfert de vos données de façon licite vers des pays situés en dehors de l’UE, ou pour obtenir une copie de ces clauses, vous pouvez nous contacter (section "
                  ),
                  _c("b", [_vm._v("Nous contacter")]),
                  _vm._v(")."),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(14),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVos informations à caractère personnel vous appartiennent. Vous pouvez nous demander à accéder aux informations que nous avons collectées, nous demander de les supprimer ou de corriger toute inexactitude. Vous pouvez également nous demander de restreindre ou limiter le traitement, le partage ou le transfert de vos informations à caractère personnel, ou en demandé la portabilité. Pour exercer vos droits, consultez la section Nous contacter. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNous vous informons qu’une demande de suppression de vos informations à caractère personnel, peut avoir pour conséquence de limiter ou rendre impossible l’accès ou l’utilisation des Services. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSi vous demandez la suppression d’informations à caractère personnel, vous reconnaissez que vous pouvez ne pas être en mesure d'accéder ou d'utiliser les Services et que des informations à caractère personnel résiduelles peuvent demeurer dans les systèmes et archives de Samsung pendant une durée limitée, conformément à la loi applicable.  Samsung n'utilisera pas ces informations à des fins commerciales. \nEn cas de violation des Conditions d'Utilisation de Samsung, d’une Politique Samsung ou d’une loi, Samsung peut suspendre, limiter ou résilier votre accès aux Services pour protéger ses droits, ses biens ou sa sécurité ou ceux de ses filiales, partenaires commerciaux, employés ou clients. Dans ce cas, Samsung se réserve le droit de conserver certaines informations à caractère personnel vous concernant quand bien même vous en auriez demandé la suppression conformément à la loi et/ou à sa sa politique de conservation des données. \n"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(15),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNous ne conserverons pas vos informations à caractère personnel plus longtemps que nécessaire pour les finalités pour lesquelles elles ont été collectées. Cela signifie que l'information sera détruite ou effacée de nos systèmes lorsqu’elle n'est plus nécessaire."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNous prenons les mesures appropriées pour nous assurer que nous traitons et conservons les informations vous concernant selon les règles suivantes :"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\n1. pour  la durée de fourniture du service ; "),
                  _c("br"),
                  _vm._v(
                    "\n2. pour la durée imposée par la loi ou résultant d’une obligation contractuelle de Samsung;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n3. pour la durée nécessaire à la finalité pour laquelle elle est traitée  cette durée pouvant être prolongée en cas de contrat, en vertu du droit applicable, ou pour des finalités statistiques, sous réserve de l’application de mesures de protection appropriées\n"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(16),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVous pouvez choisir de partager certaines données à caractère personnel dans le cadre de l’utilisation des Services et/ou choisir de recevoir ou de ne pas recevoir certaines communications ou informations.   "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSi vous refusez d'autoriser les Services à recueillir, stocker ou partager certaines informations, vous pourriez ne pas être en mesure d'utiliser toutes les fonctionnalités disponibles des Services."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nPour exercer vos choix, veuillez nous contacter comme indiqué dans la section "
                  ),
                  _c("b", [_vm._v("Nous contacter")]),
                  _vm._v(" de la présente Politique de Confidentialité. "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(17),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVous pouvez nous contacter pour exercer vos droits sur vos données, mettre à jour vos préférences, corriger vos informations, soumettre une demande ou nous poser des questions."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nVous pouvez nous contacter à l'adresse suivante :"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nGlobal Protection Office "),
                  _c("br"),
                  _vm._v("\nSamsung Electronics Co., Ltd."),
                  _c("br"),
                  _vm._v("\n129, Samsung-ro, Yeongtong-gu,"),
                  _c("br"),
                  _vm._v("\nSuwon-si, Gyeonggi-do 16677, République de Corée"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSamsung Electronics a des bureaux dans toute l’Europe, nous pouvons donc garantir que votre demande ou votre question sera traitée par l’équipe en charge de la protection des données qui se trouve dans votre région."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nLorsque vous êtes résidents au sein de l’Union Européenne, la façon la plus simple de nous contacter est d’aller sur notre Page d'Assistance à la Protection de la Vie Privée accessible ici : "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.samsung.com/request-desk",
                        target: "_blank"
                      }
                    },
                    [_vm._v("https://www.samsung.com/request-desk")]
                  ),
                  _vm._v(". "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVous pouvez également nous contacter à l’adresse suivante :"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nEuropean Data Protection Officer "),
                  _c("br"),
                  _vm._v("\nSamsung Electronics (UK) Limited"),
                  _c("br"),
                  _vm._v("\nSamsung House"),
                  _c("br"),
                  _vm._v("\n1000 Hillswood Drive"),
                  _c("br"),
                  _vm._v("\nChertsey, Surrey KT16 0PS"),
                  _c("br"),
                  _vm._v("\nRoyaume-Uni"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVous pouvez déposer une réclamation auprès de l'autorité de contrôle compétente si vous estimez que notre traitement de vos informations à caractère personnel effectué enfreint le droit applicable. Les coordonnées des autorités de contrôle pour l'ensemble de l’UE sont disponibles à l'adresse suivante : "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080",
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v(
                        "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080"
                      )
                    ]
                  ),
                  _vm._v("."),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nLes informations que vous nous communiquez sont traitées par Samsung Electronics Co. en tant que responsables de traitement, et par leurs sous-traitants, le cas échéant, pour vous fournir le contenu ou les services demandés."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVous pouvez retirer votre consentement et/ou exercer votre droit d’accès, d’opposition, de rectification, de suppression et de portabilité sur les données qui vous concernent, à tout moment, depuis la page http://www.samsung.com/request-desk. Merci de préciser que vous êtes un professionnel. Vous disposez du droit d’introduire une réclamation auprès de la CNIL. Pour plus d’informations, consultez la Politique de confidentialité Portail Samsung Documentation Services."
                  ),
                  _c("br")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.languageCd == "de"
              ? _c("div", { staticClass: "terms-detail" }, [
                  _vm._v("\nWirksam ab:  1. Januar 2021"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    '\nSamsung Electronics Co., Ltd. (Datenverantwortliche) ("'
                  ),
                  _c("b", [_vm._v("Samsung")]),
                  _vm._v(
                    '") weiß, wie wichtig der Datenschutz für seine Kunden und deren Mitarbeiter und Partner ist, und wir bemühen uns, klar darzustellen, wie wir Ihre Daten erfassen, verwenden, offenlegen, übertragen und speichern. Diese Datenschutzrichtlinie gibt einen Überblick über unsere Informationspraktiken in Bezug auf personenbezogene Daten, die mittels Dienstleistungen und Services über das Service-Wissensportal von gewerblichen Kunden (die "'
                  ),
                  _c("b", [_vm._v("Geschäftsdienstleistungen")]),
                  _vm._v('") gesammelt werden. '),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nDiese Datenschutzrichtlinie kann in regelmäßigen Abständen aktualisiert werden, um Änderungen in unserer Datenschutzpraxis in Bezug auf die Geschäftsdienstleistungen oder Änderungen des geltenden Rechts zu berücksichtigen. Am Anfang dieser Datenschutzrichtlinie vermerken wir, wann sie zuletzt aktualisiert wurde. Wenn wir die Datenschutzrichtlinie aktualisieren, informieren wir Sie im Voraus über die von uns als wesentlich erachteten Änderungen, indem wir einen Hinweis mittels unserer Geschäftsdienstleistungen veröffentlichen oder Ihnen gegebenenfalls eine E-Mail zusenden."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(18),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWir sammeln verschiedene Arten von personenbezogenen Daten in Verbindung mit den Geschäftsdienstleistungen.  "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nZum Beispiel:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tWir sammeln die von Ihnen zur Verfügung gestellten personenbezogenen Daten, wie Ihren Namen, Ihre E-Mail-Adresse und Kontaktdaten sowie alle Mitteilungen, die Sie uns zusenden oder zustellen;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tWir sammeln Daten über Dienstleistungen und Services, die Sie oder Ihr Arbeitgeber erhalten haben, und andere Daten, die im Zusammenhang mit den Geschäftsdienstleistungen zur Verfügung gestellt wurden, z.B. Daten, die bei der Erbringung von Reparaturdienstleistungen gesammelt wurden, einschließlich der Frage, welches Produkt der betroffenen Person zugeordnet war, ob das System dies genehmigt hat, die Gesamthistorie und das Datum, an dem das System eine Anforderung von Nutzern erhalten hat; und"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\twir können auch personenbezogene Daten über Sie von Ihrem Arbeitgeber oder Dienstleistungsanbieter oder aus öffentlich und kommerziell zugänglichen Quellen erhalten (soweit gesetzlich zulässig), die wir mit anderen Daten kombinieren können, die wir von Ihnen oder über Sie erhalten (soweit gesetzlich zulässig)."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(19),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWir können die von uns gesammelten Daten für folgende Zwecke verwenden: "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tum Dienstleistungen und Services zu erbringen, die Sie (oder Ihr Arbeitgeber) angefordert haben, und um Sie und Ihr Unternehmen zu registrieren oder zu authentifizieren;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tum auf Ihre Fragen oder Anforderungen von Information zu antworten;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tum bessere Dienstleistungen und Services anzubieten, die die Historie der Ihrem Unternehmen erbrachten Dienstleistungen und Services und andere relevante Informationen berücksichtigen;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tum Sie vorbehaltlich Ihrer gesonderten Zustimmung, wenn dies nach geltendem Recht erforderlich ist, über neue Produkte und Dienstleistungen zu informieren;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tfür die Bewertung und Analyse unseres Marktes, unserer Kunden, Produkte und Dienstleistungen (einschließlich der Bitte um Ihre Meinung zu unseren Produkten und Dienstleistungen und der Durchführung von Kundenumfragen);"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tum zu verstehen, wie Unternehmen die Geschäftsdienstleistungen nutzen, so dass wir sie verbessern und neue Produkte und Dienstleistungen entwickeln können; "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tzur Erbringung von Wartungsdienstleistungen und zur Aufrechterhaltung eines ausreichenden Sicherheitsniveaus bei den Geschäftsdienstleistungen;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tzum Schutz der Rechte, des Eigentums oder der Sicherheit von Samsung oder eines unserer jeweiligen verbundenen Unternehmen, Geschäftspartner, Mitarbeiter oder Kunden, z.B. bei Gerichtsverfahren, internen Untersuchungen und Ermittlungen durch zuständige Behörden;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tanderweitig mit Ihrer gesonderten Zustimmung, wenn dies nach geltendem Recht erforderlich ist oder wie zum Zeitpunkt der Erfassung Ihrer Daten beschrieben."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSamsung verarbeitet personenbezogene Daten für die oben beschriebenen Zwecke. Die rechtliche Grundlage von Samsung zur Verarbeitung personenbezogener Daten umfasst die Verarbeitung: "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(i) Damit wir unsere Versprechen an Sie einhalten können, wie zum Beispiel die Bereitstellung der Geschäftsdienstleistung;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(ii) um unsere Geschäftsinteressen zu fördern (zum Beispiel, um unsere Beziehung mit Ihnen zu verwalten); und"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(iii) zur Einhaltung des Gesetzes und um rechtlichen Verfahren zu entsprechen;"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(20),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWir geben Ihre Daten intern innerhalb unseres Unternehmens weiter, aber nur an diejenigen, die sie zur Erbringung weiterer Dienstleistungen und Services oder zur Unterstützung bei der Bearbeitung Ihrer Anforderungen und Anfragen benötigen. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWir geben Ihre Daten auch an die folgenden Stellen weiter, jedoch nur in dem Maße, wie dies für die Bereitstellung der Geschäftsdienstleistungen erforderlich ist:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n• Tochtergesellschaften: Andere Unternehmen der Samsung Electronics Group, die wir kontrollieren oder besitzen. "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n• Andere Parteien, wenn dies gesetzlich vorgeschrieben ist oder zum Schutz unseres Unternehmens erforderlich ist: Zum Beispiel kann es durch Gesetz, Gerichtsverfahren oder Gerichtsbeschluss von Regierungsbehörden erforderlich sein, Ihre Daten offenzulegen. Sie können Ihre Daten von uns auch zum Zwecke der Rechtsdurchsetzung, der nationalen Sicherheit, der Terrorismusbekämpfung oder zu anderen Fragen im Zusammenhang mit der öffentlichen Sicherheit von uns anfordern."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n• Andere Parteien im Zusammenhang mit Unternehmenstransaktionen: Wir können Ihre Daten als Teil einer Fusion oder Übertragung, eines Erwerbs oder Verkaufs oder im Falle eines Konkurses an eine dritte Partei weitergeben."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n• Andere Parteien mit Ihrer Zustimmung oder auf Ihre Anweisung: Zusätzlich zu den in dieser Datenschutzrichtlinie beschriebenen Offenlegungen können wir Daten von Ihnen an Dritte weitergeben, wenn Sie einer solchen Weitergabe gesondert zustimmen oder darum ersuchen."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(21),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWir nehmen den Datenschutz ernst. Wir haben physische und technische Sicherheitsvorkehrungen getroffen, um die von uns gesammelten Daten sicher aufzubewahren. Bitte beachten Sie jedoch, dass, obwohl wir angemessene Maßnahmen zum Schutz Ihrer Daten ergreifen, keine Website, Internetübertragung, kein Computersystem und keine drahtlose Verbindung vollkommen sicher ist.\n"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(22),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    '\nIhre Nutzung der oder Ihre Teilnahme an den Geschäftsdienstleistungen kann die Übertragung, Speicherung und Verarbeitung Ihrer Daten außerhalb des Landes Ihres Wohnsitzes in Übereinstimmung mit dieser Richtlinie beinhalten. Zu diesen Ländern gehört die Republik Korea. Bitte beachten Sie, dass Datenschutzgesetze und andere Gesetze der Länder, in die Ihre Daten übertragen werden können, möglicherweise nicht so umfassend sind wie die in Ihrem Land. Wir ergreifen in Übereinstimmung mit dem geltenden Recht geeignete Maßnahmen, um sicherzustellen, dass Ihre personenbezogenen Daten geschützt bleiben. Zu diesen Maßnahmen gehört die Verwendung von Standardvertragsklauseln, um die Übertragung von Daten außerhalb des EWR zu gewährleisten. Für weitere Informationen über die Schutzmaßnahmen, die wir ergreifen, um die rechtmäßige Übertragung Ihrer Daten in Länder außerhalb der EU zu gewährleisten, oder um eine Kopie der geltenden vertraglichen Vereinbarungen zu erhalten, wenden Sie sich bitte über die im Abschnitt „Kontakt" dieser Datenschutzrichtlinie beschriebenen Wege an uns.'
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(23),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    '\nIhre personenbezogenen Daten gehören Ihnen. Sie können uns auffordern, Ihnen Einzelheiten über die von uns gesammelten Daten mitzuteilen, und Sie können uns bitten, diese zu löschen oder etwaige Ungenauigkeiten zu korrigieren. Sie können uns auch bitten, die Verarbeitung, gemeinsame Nutzung oder Übertragung Ihrer personenbezogenen Daten einzuschränken oder zu begrenzen, sowie Ihnen Ihre von uns gesammelten personenbezogenen Daten zur Verfügung zu stellen, damit Sie sie für Ihre eigenen Zwecke verwenden können. Um Ihre Rechte auszuüben, kontaktieren Sie uns bitte über die im Abschnitt „Kontakt" dieser Datenschutzrichtlinie beschriebenen Wege. '
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nDie Anforderung der Löschung Ihrer personenbezogenen Daten kann jedoch auch zu einem Verlust des Zugangs zu den Geschäftsdienstleistungen führen."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWenn Sie die Löschung personenbezogener Daten beantragen, erkennen Sie an, dass Sie möglicherweise nicht in der Lage sein werden, auf die Geschäftsdienstleistungen zuzugreifen oder diese zu nutzen, und dass verbleibende personenbezogenen Daten in Übereinstimmung mit geltendem Recht noch einige Zeit in den Aufzeichnungen und Archiven von Samsung verbleiben können, aber Samsung wird diese Daten nicht für kommerzielle Zwecke nutzen. Sie verstehen, dass Samsung sich trotz Ihrer Bitte um Löschung das Recht vorbehält, Ihre personenbezogenen Daten oder einen relevanten Teil davon in Übereinstimmung mit unserer Richtlinie zur Datenspeicherung und den geltenden Gesetzen aufzubewahren, wenn Samsung Ihren Zugriff auf die Website wegen Verstoßes gegen die Samsung-Nutzungsbedingungen oder andere geltende Samsung-Richtlinien oder geltendes Recht ausgesetzt, eingeschränkt oder beendet hat, wenn dies zum Schutz der Rechte, des Eigentums oder der Sicherheit von Samsung oder eines unserer jeweiligen verbundenen Unternehmen, Geschäftspartner, Mitarbeiter oder Kunden erforderlich ist."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(24),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWir werden Ihre personenbezogenen Daten nicht länger aufbewahren, als es für den Zweck, für den sie gesammelt wurden, erforderlich ist. Das bedeutet, dass Daten vernichtet oder von unseren Systemen gelöscht werden, wenn sie nicht mehr benötigt werden."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWir ergreifen geeignete Maßnahmen, um sicherzustellen, dass wir Daten über Sie auf der Grundlage der folgenden Logik verarbeiten und aufbewahren:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n1. Mindestens die Dauer, während der die Daten verwendet werden, um Ihnen eine Dienstleistung zu erbringen; "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n2. wie gesetzlich vorgeschrieben, gemäß einem Vertrag oder im Hinblick auf unsere gesetzlichen Verpflichtungen;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n3. nur so lange, wie dies für den Zweck erforderlich ist, für den sie erhoben wurden oder verarbeitet werden, oder länger, falls dies gemäß einem Vertrag, gemäß geltendem Recht oder für statistische Zwecke erforderlich ist, vorbehaltlich angemessener Schutzmaßnahmen."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(25),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nWir bieten Ihnen verschiedene Optionen im Zusammenhang mit den personenbezogenen Daten, die wir über Sie erhalten.  "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nMit den Geschäftsdienstleistungen können Optionen in Bezug auf die Erhebung, Löschung und Weitergabe bestimmter Daten im Zusammenhang mit den Geschäftsdienstleistungen angeboten werden. Wenn Sie es ablehnen, mit den Geschäftsdienstleistungen zuzulassen, dass bestimmte Daten erfasst, gespeichert oder weitergegeben werden, können Sie möglicherweise nicht alle Funktionen nutzen, die über die Geschäftsdienstleistungen zur Verfügung stehen."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    '\nUm Ihre Optionen auszuüben, kontaktieren Sie uns bitte wie im Abschnitt "'
                  ),
                  _c("b", [_vm._v("Kontakt")]),
                  _vm._v('" dieser Datenschutzrichtlinie angegeben.  '),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(26),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSie können sich mit uns in Verbindung setzen, um Ihre Präferenzen zu aktualisieren, Ihre Daten zu korrigieren, eine Anforderung einzureichen oder uns Fragen zu stellen.\n"
                  ),
                  _c("br"),
                  _c("br"),
                  _vm._v("\nSie erreichen uns unter:\n"),
                  _c("br"),
                  _c("br"),
                  _vm._v("\nData Controller"),
                  _c("br"),
                  _vm._v("\nSamsung Electronics Co., Ltd."),
                  _c("br"),
                  _vm._v("\n129, Samsung-ro, Yeongtong-gu,"),
                  _c("br"),
                  _vm._v("\nSuwon-si, Gyeonggi-do 16677, Republic of Korea"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSamsung Electronics hat Niederlassungen in ganz Europa, so dass wir sicherstellen können, dass Ihre Anfrage oder Ihr Anliegen von dem in Ihrer Region ansässigen Datenschutzteam bearbeitet wird."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nDer einfachste Weg, uns zu kontaktieren, ist über unsere Support-Seite zum Datenschutz unter "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.samsung.com/request-desk",
                        target: "_blank"
                      }
                    },
                    [_vm._v("https://www.samsung.com/request-desk")]
                  ),
                  _vm._v(". "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nSie können uns auch kontaktieren unter:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nEuropean Data Protection Officer"),
                  _c("br"),
                  _vm._v("\nSamsung Electronics (UK) Limited"),
                  _c("br"),
                  _vm._v(
                    "\nSamsung House, 1000 Hillswood Drive, Chertsey, Surrey KT16 0PS"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSie können bei der zuständigen Aufsichtsbehörde eine Beschwerde einreichen, wenn Sie der Meinung sind, dass unsere Verarbeitung Ihrer personenbezogenen Daten gegen geltendes Recht verstößt. Die Kontaktdaten aller EU-Aufsichtsbehörden finden Sie unter "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080",
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v(
                        "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080"
                      )
                    ]
                  ),
                  _vm._v(".\n                        ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.languageCd == "it"
              ? _c("div", { staticClass: "terms-detail" }, [
                  _vm._v("\nApplicabile da: 1° gennaio 2021"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNoi di Samsung Electronics Co., Ltd. (Titolare del trattamento) (“"
                  ),
                  _c("b", [_vm._v("Samsung")]),
                  _vm._v(
                    "”) sappiamo quanto sia importante la privacy per i nostri clienti e per i loro dipendenti e partner, e ci sforziamo di essere chiari sul modo in cui raccogliamo, utilizziamo, divulghiamo, trasferiamo e memorizziamo le tue informazioni. La presente Privacy Policy fornisce una panoramica delle nostre pratiche relative alle informazioni personali raccolte attraverso i servizi del Portale Service Knowledge dedicato ai clienti commerciali (i “"
                  ),
                  _c("b", [_vm._v("Servizi Business")]),
                  _vm._v("”)."),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nLa presente Privacy Policy può essere aggiornata periodicamente per riflettere i cambiamenti nelle nostre pratiche di trattamento dei dati personali con riferimento ai Servizi Business o i cambiamenti nella legge applicabile. Indicheremo all’inizio della presente Privacy Policy la data di aggiornamento più recente. Nel caso in cui aggiornassimo la nostra Privacy Policy, ti informeremo in anticipo sulle modifiche che consideriamo rilevanti, pubblicando un avviso sui Servizi Business o inviandoti un’e-mail, se ritenuto opportuno."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(27),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nRaccogliamo diversi tipi di informazioni personali nell’ambito dei Servizi Business.  "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nA titolo esemplificativo:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tRaccogliamo le informazioni personali che tu fornisci, come il tuo nome, l’indirizzo e-mail e i tuoi dati di contatto, così come ogni altra comunicazione che tu ci invii o recapiti; "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tRaccogliamo informazioni sui servizi di cui tu o il tuo datore di lavoro avete fruito e altre informazioni fornite in relazione ai Servizi Business tra cui, a titolo esemplificativo, informazioni raccolte in relazione alla fornitura di servizi di riparazione, compreso quale prodotto è stato assegnato all'interessato, se il sistema lo ha approvato, la storia complessiva e la data in cui il sistema ha ricevuto una richiesta da parte dell’utente; e"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tPossiamo anche ricevere informazioni personali su di te dal tuo datore di lavoro o fornitore di servizi o da fonti pubblicamente e commercialmente disponibili (come consentito dalla legge), che potremmo combinare con altre informazioni che riceviamo da o su di te (come consentito dalla legge)."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(28),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nPossiamo utilizzare i dati che raccogliamo per le seguenti finalità:  "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tper la fornitura dei servizi richiesti da te (o dal tuo datore di lavoro) e per la registrazione e l’autenticazione tua o della tua società;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tper offrire servizi migliori che tengano conto dei dello storico dei servizi della tua società o di altre informazioni rilevanti;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tprevio tuo specifico consenso, ove richiesto dalla legge applicabile, per informarti sui nuovi prodotti e servizi;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tper la valutazione e l’analisi del nostro mercato, dei clienti, dei prodotti e dei servizi (compresa la richiesta delle tue opinioni sui nostri prodotti e servizi e l’esecuzione di indagini sui clienti);"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tcapire il modo in cui le aziende utilizzano i Servizi Business in modo da poterli migliorare e sviluppare nuovi prodotti e servizi;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tfornire servizi di manutenzione e mantenere un livello di sicurezza sufficiente sui Servizi Business;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tper proteggere i diritti, la proprietà o la sicurezza di Samsung, o di una delle nostre affiliate, partner commerciali, dipendenti o clienti, ad esempio, in procedimenti legali, indagini interne e indagini da parte delle autorità competenti;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tsecondo altre finalità con il tuo consenso specifico, se richiesto dalla legge applicabile o come descritto al momento della raccolta dei tuoi dati."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSamsung tratta i dati personali per le finalità descritte sopra. La base giuridica utilizzata da Samsung per trattare i dati personali include il trattamento:"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(i)\tFinalizzato a rispettare le promesse a te fatte, di modo da fornirti i Servizi Business;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(ii)\tFunzionale a promuovere i nostri interessi aziendali (ad esempio, per gestire la nostra relazione con te); e"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(iii)\tNecessario per conformarsi ad obblighi di legge o a procedimenti legali;"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(29),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nCondivideremo i tuoi dati internamente alla nostra azienda, ma solo con coloro che ne hanno bisogno per fornire ulteriori servizi o per aiutarti con le tue richieste. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nInoltre, condivideremo i tuoi dati ai seguenti soggetti, solo nella misura in cui ciò sarà necessario per fornire i Servizi Business:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tAffiliate: altre società del Gruppo Samsung Electronics che noi controlliamo o di cui siamo titolari. "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tAltre parti quando richiesto dalla legge o come necessario per proteggere la nostra attività: ad esempio, potrebbe essere necessario condividere i tuoi dati per via di un obbligo di legge, per un procedimento legale o per un ordine del tribunale, o per una richiesta delle autorità governative. Tali soggetti possono anche richiederci i tuoi dati ai sensi della normativa in materia di sicurezza nazionale, antiterrorismo o altre questioni relative alla sicurezza pubblica."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tAltri soggetti in relazione alle operazioni societarie: possiamo divulgare i tuoi dati a terzi nell’ambito di una fusione o trasferimento, acquisizione o vendita, o in caso di fallimento."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tAltre parti con il tuo consenso o sotto la tua direzione: oltre alle informazioni descritte nella presente Privacy Policy, possiamo condividere le informazioni su di te con terzi quando tu acconsenti o richiedi separatamente tale condivisione."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(30),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nPrendiamo sul serio la protezione dei dati. Abbiamo messo in atto misure di sicurezza fisica e tecnica per mantenere sicure le informazioni che raccogliamo. Tuttavia, ti preghiamo di notare che, anche se adottiamo misure ragionevoli per proteggere i tuoi dati, nessun sito web, trasmissione Internet, sistema informatico o connessione wireless è completamente sicuro.\n"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(31),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nL’utilizzo o la partecipazione ai Servizi Business può comportare il trasferimento, l’archiviazione e l’elaborazione delle informazioni al di fuori del paese di residenza, in linea con questa politica. Tali paesi includono la Repubblica di Corea. Le leggi sulla protezione dei dati e le altre leggi dei paesi in cui le tue informazioni possono essere trasferite potrebbero non essere così complete come quelle del tuo paese. Adotteremo misure appropriate, in conformità con la legge applicabile, per garantire che le tue informazioni personali rimangano protette. Tali misure includono l’uso di clausole contrattuali standard per salvaguardare il trasferimento dei dati al di fuori del SEE. Per ulteriori informazioni sulle misure di salvaguardia che adottiamo per garantire il legittimo trasferimento dei tuoi dati verso paesi al di fuori dell'UE, o per ottenere una copia degli accordi contrattuali in vigore, ti preghiamo di contattarci secondo le modalità descritte nella sezione Contattaci della presente Privacy Policy."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(32),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nI tuoi dati personali ti appartengono. Puoi chiederci di fornire dettagli sui dati che abbiamo raccolto e puoi chiederci di cancellarli o di correggere eventuali inesattezze. Puoi anche chiederci di restringere o limitare il trattamento, la condivisione o il trasferimento dei tuoi dati personali, nonché di fornirci le tue informazioni personali che abbiamo raccolto in modo da poterle utilizzare per i tuoi scopi. Per esercitare i tuoi diritti, ti preghiamo di contattarci secondo le modalità descritte nella sezione Contattaci della presente Privacy Policy."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nTuttavia, richiedere la cancellazione dei tuoi dati personali può anche comportare la perdita dell’accesso ai Servizi Business. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSe richiedi la cancellazione dei tuoi dati personali, riconosci che potresti non essere in grado di accedere o utilizzare i Servizi Business e che i dati personali residui potrebbero continuare a risiedere nei registri e negli archivi di Samsung per un certo periodo di tempo in conformità con la legge applicabile, ma Samsung non utilizzerà tali informazioni per scopi commerciali. Sei consapevole che, nonostante la tua richiesta di cancellazione, Samsung si riserva il diritto di conservare le tue informazioni personali, o una parte rilevante di esse, in linea con la nostra politica di conservazione dei dati e con le leggi applicabili, qualora Samsung abbia sospeso, limitato o interrotto il tuo accesso al sito web per aver violato le Condizioni d’Uso Samsung o qualsiasi altra politica Samsung applicabile o legge applicabile, quando necessario per proteggere i diritti, la proprietà o la sicurezza di Samsung, o di una delle nostre affiliate, dei nostri partner commerciali, dipendenti o clienti."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(33),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNon conserveremo i tuoi informazioni personali per un periodo di tempo superiore a quello necessario allo scopo per cui sono stati raccolti. Ciò significa che i dati saranno distrutti o cancellati dai nostri sistemi quando non saranno più necessari."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nAdottiamo le misure appropriate per garantire che i tuoi dati siano trattati e conservato in base alla seguente logica: "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n1.\tAlmeno la durata per cui i dati vengono utilizzati per fornire un servizio;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n2.\tCome richiesto dalla legge, da un contratto o nella misura in cui ciò sia necessario per i nostri obblighi statutari;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n3.\tSolo per il tempo necessario allo scopo per il quale sono stati raccolti, sono trattati, o più a lungo se richiesto da un contratto, dalla legge applicabile, o a fini statistici, fatte salve adeguate garanzie."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(34),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nTi offriamo diverse scelte con riguardo ai dati personali che raccogliamo su di te.  "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "  \nI Servizi Business possono offrire scelte relative alla raccolta, alla cancellazione e alla condivisione di alcune informazioni relative ai Servizi Business. Se rifiuti di consentire ai Servizi Business di raccogliere, archiviare o condividere determinate informazioni, potresti non essere in grado di utilizzare tutte le funzionalità disponibili attraverso i Servizi Business."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "  \nPer esprimere le tue scelte, contattaci come contattato alla sezione "
                  ),
                  _c("b", [_vm._v("Contattaci")]),
                  _vm._v(" di questa Privacy Policy.  \n"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(35),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nPuoi contattarci per aggiornare le tue preferenze, correggere i tuoi dati, inviare una richiesta o farci delle domande."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nPuoi contattarci a:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nTitolare del trattamento"),
                  _c("br"),
                  _vm._v("\nSamsung Electronics Co., Ltd."),
                  _c("br"),
                  _vm._v("\n129, Samsung-ro, Yeongtong-gu,"),
                  _c("br"),
                  _vm._v("\nSuwon-si, Gyeonggi-do 16677, Repubblica di Corea"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSamsung Electronics ha uffici in tutta Europa, quindi possiamo garantire che la tua richiesta o domanda sarà gestita dal team di protezione dei dati con sede nella tua regione."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nLa via più semplice per contattarci è attraverso la nostra Pagina Supporto Privacy disponibile a "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.samsung.com/request-desk",
                        target: "_blank"
                      }
                    },
                    [_vm._v("https://www.samsung.com/request-desk")]
                  ),
                  _vm._v(". "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nPuoi anche contattarci a:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nEuropean Data Protection Officer"),
                  _c("br"),
                  _vm._v("\nSamsung Electronics (UK) Limited"),
                  _c("br"),
                  _vm._v(
                    "\nSamsung House, 1000 Hillswood Drive, Chertsey, Surrey KT16 0PS"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nPuoi presentare un reclamo all’autorità di controllo competente se ritieni che il trattamento dei tuoi dati personali da parte nostra violi la legge applicabile. I recapiti di tutte le autorità di controllo dell’UE sono disponibili all'indirizzo: \n"
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080",
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v(
                        "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080"
                      )
                    ]
                  ),
                  _vm._v(".\n                        ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.languageCd == "pt"
              ? _c("div", { staticClass: "terms-detail" }, [
                  _vm._v("\nEntrada em vigor: 1 de janeiro de 2021"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nA Samsung Electronics Co., Ltd. (Responsável pelo tratamento) (“"
                  ),
                  _c("b", [_vm._v("Samsung")]),
                  _vm._v(
                    '”) sabe como a privacidade é importante para os seus clientes, funcionários e parceiros, e esforça-se para ser clara sobre a forma como recolhe, utiliza, divulga, transfere e armazena os seus dados. A presente Política de Privacidade fornece uma visão geral sobre as nossas práticas de informação relativas a dados pessoais recolhidos através dos serviços do "Service Knowledge Portal" junto de clientes comerciais (os '
                  ),
                  _c("b", [_vm._v("Serviços Empresariais")]),
                  _vm._v('").  '),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nA presente Política de Privacidade pode ser atualizada periodicamente para refletir alterações nas nossas práticas em matéria de dados pessoais no âmbito dos Serviços Empresariais ou de alterações à legislação aplicável. Iremos indicar, no cabeçalho da presente Política de Privacidade qual a data da sua atualização mais recente. Se atualizarmos a Política de Privacidade, comunicaremos esse facto com antecedência sobre as alterações que considerarmos relevantes, através da publicação de um aviso nos Serviços Empresariais ou do envio de um email, nos casos em que tal for adequado."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(36),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nIremos recolher vários tipos de dados pessoais relacionados com os Serviços Empresariais.  "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nPor exemplo:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tIremos recolher dados pessoais que o utilizador fornecer, como por exemplo, o nome, endereço de email e dados de contacto, e quaisquer comunicações que nos enviar ou entregar;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tIremos recolher dados sobre os serviços que o utilizador ou a entidade empregadora respetiva tiverem recebido e outros dados fornecidos no âmbito dos Serviços Empresariais, por exemplo, dados recolhidos em conexão com a prestação de serviços de reparação, incluindo que produto foi atribuído ao titular dos dados, se o sistema o aprovou, o histórico geral e a data em que o sistema recebeu um pedido dos utilizadores; e"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tTambém podemos receber dados pessoais sobre o utilizador ou a respetiva entidade empregadora ou prestador de serviços ou de fontes disponíveis pública e comercialmente (conforme permitido por lei), que poderemos conjugar com outros dados que recebemos junto do ou sobre o utilizador (conforme permitido por lei)."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(37),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nPoderemos utilizar os dados pessoais do utilizador com vista às seguintes finalidades: "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tpara fornecer serviços que o utilizador (ou a sua entidade empregadora) solicitou e para registar ou autenticar o utilizador ou a sua empresa;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tpara responder às perguntas ou pedidos de informação dos utilizadores;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tpara oferecer melhores serviços que tenham em conta o registo de assistência da empresa do utilizador e outros dados relevantes;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tdesde que tal seja autorizado de forma expressa pelo utilizador, quando tal for exigido pela legislação aplicável, para informar o utilizador sobre novos produtos e serviços;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tpara avaliação e análise do nosso mercado, clientes, produtos e serviços (incluindo solicitar a opinião dos utilizadores sobre os nossos produtos e serviços e realizar inquéritos aos clientes);"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tpara entender a forma como as empresas usam os Serviços Empresariais para que possamos melhorá-los e desenvolver novos produtos e serviços; "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tpara prestar serviços de manutenção e manter um nível de segurança suficiente dos Serviços Empresariais;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tpara proteger os direitos, os ativos ou a segurança da Samsung ou de qualquer uma das nossas afiliadas, parceiros comerciais, funcionários ou clientes, por exemplo, em processos judiciais, inquéritos internos e investigações realizadas pelas autoridades competentes;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\te ainda, com o consentimento expresso dos utilizadores, quando tal for exigido pela legislação aplicável ou conforme descrito no momento em que os dados dos utilizadores são recolhidos."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nA Samsung procede ao tratamento de dados pessoais para as finalidades acima indicadas. A fundamentação legal da Samsung para efetuar o tratamento de dados pessoais inclui o tratamento: "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(i) Para que possamos cumprir as nossas promessas perante os utilizadores, como por exemplo prestar aos utilizadores o Serviço Empresarial;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(ii) Para promover os nossos interesses comerciais (por exemplo, para gerir o nosso relacionamento com os utilizadores); e"
                  ),
                  _c("br"),
                  _vm._v("\n(iii) Para cumprir a lei e os mecanismos legais."),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(38),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nDivulgaremos os dados do utilizador internamente no âmbito da nossa atividade, mas apenas para as pessoas que deles necessitam para prestar serviços adicionais ou para prestar apoio ao utilizador no âmbito das suas solicitações. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nTambém divulgaremos os dados do utilizador às seguintes entidades, apenas na medida em que isso seja necessário para a prestação dos Serviços Empresariais:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    '\n• Afiliadas: outras empresas do grupo "Samsung Electronics Group" que controlamos ou detemos. '
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n• Outras partes, quando exigido por lei ou conforme necessário para proteger a nossa empresa: Por exemplo, pode ser necessário por lei, no âmbito de um processo judicial ou em resultado de uma ordem judicial divulgar os dados de um utilizador. Estas entidades também poderão solicitar-nos o fornecimento de dados para efeitos de aplicação da lei, segurança nacional, antiterrorismo ou outras matérias relacionadas com a segurança pública."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n• Outras partes relativamente a transações no âmbito societário: poderemos divulgar dados do utilizador a terceiros no âmbito de uma fusão ou cessão de ativos, aquisição ou venda, ou em caso de insolvência."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n• Outras partes com o consentimento do utilizador ou sob a orientação deste: para além das divulgações descritas na presente Política de Privacidade, poderemos partilhar informações sobre o utilizador com terceiros se o utilizador autorizar ou solicitar de forma expressa essa partilha."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(39),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nLevamos a proteção de dados muito a sério. Implementámos proteções físicas e técnicas para manter seguros os dados que recolhemos. No entanto, deverá ser tido em atenção que, embora tomemos medidas razoáveis para proteger os dados pessoais dos utilizadores nenhum website, transmissão de Internet, sistema informático ou ligação sem fios é completamente seguro.\n"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(40),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nA utilização ou participação do utilizador nos Serviços Empresariais pode envolver a transferência, armazenamento e tratamento dos dados pessoais do utilizador fora do seu país de residência, de acordo com a presente política. Entre esses países inclui-se a República da Coreia. Deverá ter em atenção que a proteção de dados e a legislação dos países para os quais os dados dos utilizadores podem ser transferidos podem não ser tão abrangentes como as aplicáveis no seu país. Tomaremos as medidas adequadas, em conformidade com a legislação aplicável, para garantir que os dados pessoais do utilizador permanecem protegidos. Essas medidas incluem a utilização de Cláusulas Contratuais Tipo para salvaguardar a transferência de dados para fora do EEE. Para obter mais informações sobre as medidas de salvaguarda que tomamos para garantir a transferência legal dos dados dos utilizadores para países fora da UE, ou para obter uma cópia dos acordos contratuais em vigor, poderá entrar em contacto connosco através dos métodos descritos na secção Contacte-nos da presente Política de Privacidade."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(41),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nOs dados pessoais do utilizador são propriedade do mesmo. O utilizador pode solicitar-nos detalhes sobre os dados que recolhemos, e pode solicitar-nos a eliminação ou correção desses dados. O utilizador também nos pode solicitar para restringirmos ou limitarmos o tratamento, partilha ou transferência dos seus dados pessoais, bem como solicitar que lhe entreguemos os dados pessoais que recolhemos para que as possa utilizar para os seus próprios fins. Para exercer os seus direitos, o utilizador deverá entrar em contacto connosco através dos métodos indicados na secção Contacte-nos da presente Política de Privacidade. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNo entanto, solicitar a eliminação dos seus dados pessoais também pode dar origem a perda de acesso aos Serviços Empresariais. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSe um utilizador solicitar a eliminação dos dados pessoais, reconhece que pode deixar de aceder ou de utilizar os Serviços Empresariais e que dados pessoais residuais podem continuar a existir nos registos e arquivos da Samsung durante algum tempo, em conformidade com a legislação aplicável, mas a Samsung não irá utilizar esses dados para fins comerciais. O utilizador reconhece que, apesar de sua solicitação de eliminação, a Samsung reserva-se o direito de manter os seus dados pessoais, ou uma parte relevante dos mesmos, de acordo com a nossa política de retenção de dados e da legislação aplicável, caso a Samsung tenha suspendido, limitado ou bloqueado o seu acesso ao website em resultado de uma violação dos Termos de Utilização da Samsung ou de qualquer outra política da Samsung ou disposição legal aplicável, quando tal se revele necessário para proteger os direitos, propriedade ou segurança da Samsung ou de qualquer de nossas afiliadas, parceiros comerciais, funcionários ou clientes."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(42),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNão guardaremos os dados pessoais dos utilizadores por mais tempo do que o necessário para a finalidade para a qual os mesmos foram recolhidos. Isto significa que os dados serão destruídos ou apagados dos nossos sistemas quando deixarem de ser necessários."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nTomamos as medidas adequadas para garantir que tratamos e retemos dados dos utilizadores com base na seguinte lógica:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n1. Pelo menos durante o período de tempo durante o qual os dados são utilizados para prestar um serviço ao utilizador; "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n2. Conforme exigido por lei, por contrato ou resulte das nossas obrigações regulamentares;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n3. Apenas durante o período de tempo necessário para a finalidade para a qual os dados foram recolhidos, durante o período de tempo durante o qual os dados são tratados, ou por um período mais longo, se tal for necessário no âmbito de qualquer contrato, da legislação aplicável ou para fins estatísticos, com aplicação das devidas salvaguardas."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(43),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nDisponibilizamos aos utilizadores algumas escolhas relativas aos dados pessoais que obtemos sobre os mesmos.  "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "  \nOs Serviços Empresariais podem disponibilizar opções relacionadas com a recolha, eliminação e partilha de determinados dados relacionados com os Serviços Empresariais. Se o utilizador não conceder autorização para que os Serviços Empresariais recolham, armazenem ou partilhem determinados dados, poderá ficar impedido de utilizar todas as funcionalidades disponibilizadas através dos Serviços Empresariais."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "  \nPara exercer os seus direitos, o utilizador deverá entrar em contacto connosco conforme indicado na secção "
                  ),
                  _c("b", [_vm._v("Contacte-nos")]),
                  _vm._v(" da presente Política de Privacidade.  "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(44),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nPode entrar em contacto connosco para atualizar as suas preferências, corrigir os seus dados, enviar uma solicitação ou colocar-nos quaisquer perguntas."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nPode entrar em contacto connosco para:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nResponsável pelo Tratamento dos Dados"),
                  _c("br"),
                  _vm._v("\nSamsung Electronics Co., Ltd."),
                  _c("br"),
                  _vm._v("\n129, Samsung-ro, Yeongtong-gu,"),
                  _c("br"),
                  _vm._v("\nSuwon-si, Gyeonggi-do 16677, República da Coreia"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nA Samsung Electronics possui escritórios em toda a Europa, de forma a garantir que a sua solicitação ou dúvida é tratada pela equipa de proteção de dados localizada na sua região."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nA forma mais fácil de entrar em contacto connosco é através da nossa Página de Apoio à Privacidade em "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.samsung.com/request-desk",
                        target: "_blank"
                      }
                    },
                    [_vm._v("https://www.samsung.com/request-desk")]
                  ),
                  _vm._v(". "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nPode ainda entrar em contacto connosco para:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nEncarregado da Proteção de Dados Europeu"),
                  _c("br"),
                  _vm._v("\nSamsung Electronics (UK) Limited"),
                  _c("br"),
                  _vm._v(
                    "\nSamsung House, 1000 Hillswood Drive, Chertsey, Surrey KT16 0PS"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nPode apresentar uma reclamação à autoridade nacional de proteção de dados competente se considerar que o tratamento dos seus dados pessoais viola a legislação aplicável. Os dados de contacto de todas as autoridades nacionais de proteção de dados da UE podem ser encontrados em "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080",
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v(
                        "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080"
                      )
                    ]
                  ),
                  _vm._v(".\n                        ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.languageCd == "es"
              ? _c("div", { staticClass: "terms-detail" }, [
                  _vm._v("\nFecha de entrada en vigor:  1 de enero de 2021"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nEn Samsung Electronics Co., Ltd (Responsable del tratamiento) (“"
                  ),
                  _c("b", [_vm._v("Samsung")]),
                  _vm._v(
                    '”) sabemos la importancia que reviste la privacidad para nuestros clientes y sus empleados y socios, y nos esforzamos por ser claros sobre cómo recopilamos, utilizamos, divulgamos, transferimos y almacenamos su información. Esta Política de privacidad proporciona una descripción general de nuestras prácticas en materia de información con respecto a los datos de carácter personal recabados a través de los servicios del Portal de Conocimiento de los Servicios con clientes comerciales ("'
                  ),
                  _c("b", [_vm._v("Servicios empresariales")]),
                  _vm._v('").  '),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nEsta Política de privacidad puede actualizarse periódicamente para reflejar cambios en nuestras prácticas de información personal con respecto a Servicios Empresariales o cambios en la legislación aplicable. En la parte superior de esta Política de privacidad, le indicaremos cuándo se ha actualizado por última vez. Si actualizamos esta Política de privacidad, le informaremos de antemano acerca de los cambios que consideremos esenciales publicando un aviso en Servicios Empresariales o por correo electrónico, cuando corresponda."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(45),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nRecopilaremos varios tipos de información de carácter personal en relación con los Servicios Empresariales.  "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nPor ejemplo:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tRecabaremos la información personal que nos proporcione, como su nombre, dirección de correo electrónico y datos de contacto, y cualquier comunicación que nos envíe o entregue;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tRecopilaremos información sobre los servicios que se le hayan prestado a usted o a su empleador, así como otros datos que se hayan facilitado en relación con los Servicios Empresariales, por ejemplo, la información recabada en relación con la prestación de servicios de reparación, incluido el producto asignado al interesado, si el sistema lo ha autorizado o no, la historia general y la fecha en la que el sistema recibió cualquier solicitud del usuario; y"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tTambién podremos recibir información personal relativa a usted de su empleador, su proveedor de servicios o de fuentes disponibles pública y comercialmente (si lo permite la ley), y podremos combinarla con otros datos que recibamos de usted o en relación con usted (si lo permite la ley)."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(46),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nPodemos utilizar la información que recopilemos para las finalidades siguientes: "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tpara prestar servicios que usted (o su empleador) haya solicitado, y llevar a cabo su registro y autentificación y los de su empresa;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tpara responder a sus consultas o solicitudes de información;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tpara ofrecer mejores servicios que tengan en cuenta el historial de servicios de su empresa y otra información relevante;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tpara informarle de productos y servicios nuevos, siempre que usted dé su consentimiento expreso cuando así lo requiera la legislación aplicable;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tpara evaluar y analizar nuestro mercado y a nuestros clientes, productos y servicios (lo cual incluye solicitarle opiniones sobre nuestros productos y servicios y hacer encuestas de clientes);"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tpara comprender la forma en que las empresas usan los Servicios Empresariales de manera que podamos mejorarlos y desarrollar nuevos productos y servicios; "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tpara proporcionar servicios de mantenimiento y mantener un nivel suficiente de seguridad en los Servicios Empresariales;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tpara proteger los derechos, la propiedad o la seguridad de Samsung, o cualquiera de nuestras respectivas sociedades vinculadas, socios comerciales, empleados o clientes, por ejemplo, en procedimientos legales, investigaciones internas e investigaciones de las autoridades competentes;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tpara otras finalidades, con su consentimiento específico, cuando así lo exija la ley aplicable o según se describa en el momento en que se recopile su información."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nEn Samsung tratamos la información personal con los fines descritos con anterioridad. La base jurídica de Samsung para el tratamiento de información personal incluye el tratamiento: "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(i) Para que podamos mantener nuestros compromisos con usted, como ofrecerle el Servicio Empresarial;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(ii) Para fomentar nuestros intereses comerciales (por ejemplo, para gestionar nuestra relación con usted); y"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(iii) Para cumplir con la legislación y procedimientos legales;"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(47),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nCompartiremos su información internamente dentro de nuestra empresa, pero únicamente con quienes la necesiten para seguir prestando Servicios o para ayudar con sus solicitudes. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nAdemás, y exclusivamente en la medida en que sea necesario para la prestación de los Servicios Empresariales, podemos transmitir sus datos a las siguientes entidades:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n• Sociedades vinculadas: Otras empresas del Grupo Samsung Electronics que controlamos o poseemos. "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n• Otras partes cuando lo requiera la ley o sea necesario para proteger nuestro negocio: Por ejemplo, es posible que una ley, proceso legal u orden judicial de las autoridades nos exija divulgar su información. También pueden solicitar que divulguemos su información para el cumplimiento de requisitos legales, por seguridad nacional, lucha contra el terrorismo u otros asuntos relacionados con la seguridad pública."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n• Otras partes en relación con operaciones societarias: Podemos comunicar sus datos a terceros en el marco de cualquier fusión, transferencia, adquisición o venta, o en caso de quiebra."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n• Otras partes con su consentimiento o siguiendo sus instrucciones: Además de las divulgaciones que se describen en esta Política de privacidad, podemos compartir información sobre usted con terceros cuando usted lo autorice o lo solicite expresamente."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(48),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNos tomamos muy en serio la protección de datos. Hemos implantado medidas físicas y técnicas para mantener a salvo la información que recopilamos. Sin embargo, le rogamos que tenga en cuenta que, aunque tomamos medidas razonables para proteger sus datos, no existen páginas web, transmisiones por Internet, sistemas informáticos ni conexiones inalámbricas que sean totalmente seguras.\n"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(49),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    '\nSu uso o participación en los Servicios Empresariales puede implicar la transferencia, el almacenamiento y el tratamiento de su información fuera de su país de residencia, de conformidad con la presente política. Dichos países incluyen la República de Corea. Tenga en cuenta que el alcance de la protección de datos y otras leyes de los países a los que se puede transferir su información puede que no sea tan amplio como el de su país. Para garantizar que sus datos personales permanecen protegidos, tomaremos medidas adecuadas de conformidad con la legislación aplicable, entre ellas, el uso de cláusulas contractuales tipo para proteger la transferencia de datos fuera del EEE. Si desea obtener más información sobre las medidas de seguridad que adoptamos para garantizar la transferencia legal de sus datos a países no pertenecientes a la UE, u obtener una copia de los acuerdos contractuales vigentes, póngase en contacto con nosotros por los medios que se indican en el apartado "Contacte con nosotros" de esta Política de privacidad.'
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(50),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    '\nSu información personal le pertenece. Puede solicitarnos información detallada sobre qué datos hemos recopilado y puede solicitarnos que los eliminemos o que rectifiquemos errores en ellos. También puede solicitarnos que restrinjamos o limitemos el tratamiento, el intercambio o la transferencia de su información personal, así como que le proporcionemos la información personal que hayamos recopilado sobre usted para que pueda utilizarla para sus propios fines. Para ejercer sus derechos, contacte con nosotros por los medios que se indican en el apartado "Contacte con nosotros" de esta Política de privacidad. '
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNo obstante, solicitar la eliminación de su información personal puede dar lugar a una pérdida de acceso a los Servicios Empresariales. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSi solicita la eliminación de la información de carácter personal, asume que no puede acceder a ni utilizar los Servicios Empresariales y que podrá quedar información personal residual en los registros y archivos de Samsung durante algún tiempo de conformidad con la legislación aplicable, pero que en Samsung no la utilizaremos con fines comerciales. Usted entiende que, pese a su solicitud de eliminación, nos reservamos el derecho de conservar su información de carácter personal, o una parte relevante de ella, en consonancia con nuestra política de conservación de datos y con arreglo a las leyes aplicables, si hemos suspendido, limitado o cancelado su acceso a la página web por incumplir los Términos de uso de Samsung o cualquier otra política de Samsung o ley aplicable, si es necesario para proteger los derechos, la propiedad o la seguridad de Samsung, o de cualquiera de nuestras respectivas sociedades vinculadas, socios comerciales, empleados o clientes."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(51),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNo conservaremos sus datos personales durante más tiempo del que sea necesario para los fines para los que se recopilan. Esto quiere decir que la información se destruirá o eliminará de nuestros sistemas cuando deje de ser necesaria."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nTomamos medidas adecuadas para garantizar que tratamos y conservamos sus datos según los siguientes criterios:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n1. Como mínimo durante el tiempo que se utilicen para prestarle un servicio; "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n2. Según lo exija cualquier ley, contrato, o en relación con nuestras obligaciones legales;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n3. Solo durante el tiempo que sea necesario para los fines para los que se han recopilado o se someten a tratamiento, o durante más tiempo de conformidad con cualquier contrato, la legislación aplicable o para fines estadísticos, siempre con las garantías suficientes."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(52),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nLe ofrecemos ciertas opciones en relación con los datos personales que recabamos.  "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "  \nLos Servicios Empresariales pueden ofrecerle varias opciones en relación con la recopilación, la eliminación y el intercambio de ciertos datos relativos a los Servicios empresariales. Si rechaza permitir que los Servicios Empresariales recopilen, almacenen o compartan ciertos datos, es posible que no pueda utilizar todas las funciones disponibles a través de los Servicios Empresariales."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "  \nPara elegir las opciones que desee, contacte con nosotros de la manera indicada en el apartado "
                  ),
                  _c("b", [_vm._v("Contacte con nosotros")]),
                  _vm._v(" de esta Política de privacidad.  "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(53),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nPuede contactar con nosotros para actualizar sus preferencias, corregir su información, enviar una solicitud o hacernos alguna pregunta."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nPuede contactar con nosotros en:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nResponsable del tratamiento de datos"),
                  _c("br"),
                  _vm._v("\nSamsung Electronics Co., Ltd."),
                  _c("br"),
                  _vm._v("\n129, Samsung-ro, Yeongtong-gu,"),
                  _c("br"),
                  _vm._v("\nSuwon-si, Gyeonggi-do 16677, República de Corea"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSamsung Electronics tiene oficinas en toda Europa, por lo que podemos garantizar que el equipo de protección de datos de su región gestionará su solicitud o consulta."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nLa forma más fácil de contactar con nosotros es a través de nuestra Página de Soporte de Privacidad en "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.samsung.com/request-desk",
                        target: "_blank"
                      }
                    },
                    [_vm._v("https://www.europe-samsung.com/gdpr/webform/es")]
                  ),
                  _vm._v(". "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nTambién puede ponerse en contacto con nosotros mediante escrito a:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nDelegado de Protección de Datos de Europa"),
                  _c("br"),
                  _vm._v("\nSamsung Electronics (UK) Limited"),
                  _c("br"),
                  _vm._v(
                    "\nSamsung House, 1000 Hillswood Drive, Chertsey, Surrey KT16 0PS"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nPuede presentar una reclamación ante la autoridad de control correspondiente si considera que el tratamiento de su información personal por nuestra parte incumple la legislación aplicable. La información de contacto de todas las autoridades de control de la UE puede encontrarse en "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080",
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v(
                        "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080"
                      )
                    ]
                  ),
                  _vm._v(".\n                        ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.languageCd == "el"
              ? _c("div", { staticClass: "terms-detail" }, [
                  _vm._v("\nΗμερομηνία Έναρξης Ισχύος:  1η Ιανουαρίου 2021"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    '\nΗ Samsung Electronics Co., Ltd. (Υπεύθυνος Επεξεργασίας) ("'
                  ),
                  _c("b", [_vm._v("Samsung ή εμείς")]),
                  _vm._v(
                    '") γνωρίζουμε πόσο σημαντική είναι η προστασία των προσωπικών δεδομένων για τους πελάτες μας, τους υπαλλήλους και τους συνεργάτες τους και προσπαθούμε να είμαστε σαφείς αναφορικά με τον τρόπο που συλλέγουμε, χρησιμοποιούμε, αποκαλύπτουμε, μεταφέρουμε και αποθηκεύουμε τα στοιχεία σας. Αυτή η Πολιτική Προστασίας Προσωπικών Δεδομένων παρέχει μια επισκόπηση των πρακτικών μας σχετικά με τα δεδομένα προσωπικού χαρακτήρα που συλλέγονται μέσω της Διαδικτυακής Πύλης Πληροφοριών Επισκευής και Συντήρησης (οι «'
                  ),
                  _c("b", [_vm._v("Επιχειρηματικές Υπηρεσίες")]),
                  _vm._v("»).  \n"),
                  _c("br"),
                  _c("br"),
                  _vm._v(
                    "\nΗ παρούσα Πολιτική Προστασίας Προσωπικών Δεδομένων μπορεί να επικαιροποιείται για να αντικατοπτρίζει τις αλλαγές στις πρακτικές επεξεργασίας προσωπικών δεδομένων αναφορικά με τις Επιχειρηματικές Υπηρεσίες ή τις αλλαγές στην εφαρμοστέα νομοθεσία. Θα επισημαίνουμε στην αρχή της παρούσας Πολιτικής Προστασίας Προσωπικών Δεδομένων πότε πραγματοποιήθηκε η τελευταία επικαιροποίηση της. Σε περίπτωση που επικαιροποιήσουμε την Πολιτική Προστασίας Προσωπικών Δεδομένων, θα σας ενημερώσουμε για τις αλλαγές που θεωρούμε σημαντικές, αναρτώντας σχετική ειδοποίηση στις Επιχειριματικές Υπηρεσίες ή αποστέλλοντας σας e-mail, όπου απαιτείται.\n"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(54),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΘα συλλέγουμε διάφορα είδη δεδομένων προσωπικού χαρακτήρα που αφορούν τις Επιχειρηματικές Υπηρεσίες.  "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nΓια παράδειγμα:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tΘα συλλέγουμε δεδομένα προσωπικού χαρακτήρα που παρέχετε, όπως το όνομά σας, τη διεύθυνση ηλεκτρονικού ταχυδρομείου και τα στοιχεία επικοινωνίας, καθώς και κάθε επικοινωνία που αποστέλλετε ή παραδίδετε σε εμάς."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tΘα συλλέγουμε πληροφορίες σχετικά με τις υπηρεσίες που έχετε λάβει εσείς ή ο εργοδότης σας και άλλες πληροφορίες που παρέχονται σε σχέση με τις Επιχειρηματικές Υπηρεσίες, όπως για παράδειγμα, πληροφορίες που συλλέγονται σε σχέση με την παροχή υπηρεσιών επισκευής, συμπεριλαμβανομένου του προϊόντος που έχει ανατεθεί στο υποκείμενο των δεδομένων, εάν το σύστημα το έχει εγκρίνει, το γενικό ιστορικό και την ημερομηνία κατά την οποία το σύστημα έλαβε αίτημα από τους χρήστες, και "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tΕνδέχεται επίσης να λάβουμε δεδομένα προσωπικού χαρακτήρα για εσάς από τον εργοδότη σας ή τον φορέα παροχής υπηρεσιών ή από δημόσιες και εμπορικά διαθέσιμες πηγές (όπως επιτρέπεται από το νόμο), τα οποία ενδέχεται να συνδυάσουμε με άλλα στοιχεία που λαμβάνουμε από ή σχετικά με εσάς (όπως επιτρέπεται από τον νόμο)."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(55),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΕνδέχεται να χρησιμοποιήσουμε τις πληροφορίες που συλλέγουμε για τους ακόλουθους σκοπούς: "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tγια να παρέχουμε υπηρεσίες που εσείς (ή ο εργοδότης σας) ζητήσατε και για να καταχωρίσουμε ή να ταυτοποιήσουμε εσάς και την εταιρείας σας,"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tγια να απαντάμε στις ερωτήσεις ή αιτήματα σας για πληροφορίες,"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tγια να προσφέρουμε καλύτερες υπηρεσίες που να λαμβάνουν υπόψη το αρχείο υπηρεσιών της εταιρείας σας και άλλες σχετικές πληροφορίες,"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tγια να σας ενημερώνουμε για νέα προϊόντα και υπηρεσίες, με την επιφύλαξη της χωριστής συναίνεσής σας, όπου απαιτείται από το νόμο,"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tγια την αξιολόγηση και ανάλυση της αγοράς μας, των πελατών, των προϊόντων και των υπηρεσιών μας (συμπεριλαμβανομένων ερωτηματολογίων αναφορικά με τις απόψεις σας για τα προϊόντα και τις υπηρεσίες μας και της διεξαγωγής ερευνών ικανοποίησης πελατών),"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tγια να κατανοήσουμε τον τρόπο με τον οποίο οι εταιρείες χρησιμοποιούν τις Επιχειρηματικές Υπηρεσίες της Samsung, ώστε να μπορούμε να τις βελτιώσουμε και να αναπτύξουμε νέα προϊόντα και υπηρεσίες, "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tγια να παρέχουμε υπηρεσίες συντήρησης και να διατηρούμε ένα επαρκές επίπεδο ασφάλειας στις Επιχειρηματικές Υπηρεσίες,"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tγια την προστασία των δικαιωμάτων, της ιδιοκτησίας ή της ασφάλειας της Samsung ή οποιασδήποτε από τις αντίστοιχες συνδεδεμένες εταιρείες, τους επιχειρηματικούς συνεργάτες μας, τους εργαζομένους ή πελάτες μας, για παράδειγμα, σε νομικές διαδικασίες, εσωτερικές έρευνες και έρευνες από τις αρμόδιες αρχές,"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tάλλως με τη συναίνεσή σας, όταν απαιτείται από την ισχύουσα νομοθεσία, ή όπως περιγράφεται κατά το χρόνο συλλογής των στοιχείων σας."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΗ Samsung επεξεργάζεται δεδομένα προσωπικού χαρακτήρα για τους σκοπούς που περιγράφονται παραπάνω. Η νομική βάση της Samsung για την επεξεργασία των δεδομένων προσωπικών περιλαμβάνει την επεξεργασία: "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(i) Έτσι ώστε να μπορέσουμε να τηρήσουμε τις υποσχέσεις μας προς εσάς, όπως την παροχή των Επιχειρηματικών Υπηρεσιών,"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(ii) Να προωθήσουμε τα επιχειρηματικά μας συμφέροντα (για παράδειγμα, τη διαχείριση της σχέσης μας με εσάς), και"
                  ),
                  _c("br"),
                  _vm._v(
                    "\niii) Να συμμορφωθούμε με τη νομοθεσία και τις νομικές διαδικασίες."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(56),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΘα γνωστοποιήσουμε τα στοιχεία σας εσωτερικά εντός της επιχείρησής μας, αλλά μόνο στα άτομα που τα χρειάζονται ώστε περαιτέρω να παρέχουν Υπηρεσίες ή για να σας βοηθήσουν με τα αιτήματα σας. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΘα γνωστοποιήσουμε επίσης τις πληροφορίες σας στις ακόλουθες οντότητες, μόνο στο βαθμό που αυτό είναι απαραίτητο για την παροχή των Επιχειρηματικών Υπηρεσιών:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n• Συνδεδεμένες εταιρείες: Άλλες εταιρείες του Ομίλου Samsung Electronics που ελέγχουμε ή κατέχουμε. "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n• Άλλα μέρη όταν απαιτείται από το νόμο ή είναι αναγκαίο για την προστασία της επιχείρησής μας: Για παράδειγμα, μπορεί να χρειαστεί με νόμο, νομική διαδικασία ή δικαστική εντολή των κυβερνητικών αρχών να γνωστοποιήσουμε τα στοιχεία σας. Μπορούν επίσης να αναζητήσουν τα στοιχεία σας από εμάς για τους σκοπούς της επιβολής του νόμου, της εθνικής ασφάλειας, της καταπολέμησης της τρομοκρατίας ή άλλων θεμάτων που σχετίζονται με τη δημόσια ασφάλεια."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n• Άλλα μέρη σε σχέση με τις εταιρικές συναλλαγές: Μπορούμε να αποκαλύψουμε τα στοιχεία σας σε τρίτο μέρος στο πλαίσιο συγχώνευσης ή μεταβίβασης, αγοράς ή πώλησης ή σε περίπτωση πτώχευσης."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n• Άλλα μέρη με τη συγκατάθεσή σας ή με την κατεύθυνση σας: Εκτός από τις γνωστοποιήσεις που περιγράφονται στην παρούσα Πολιτική Προστασίας Προσωπικών Δεδομένων, μπορούμε να μοιραστούμε στοιχεία σχετικά με εσάς με τρίτους, όταν παράσχει χωριστή συναίνεση ή ζητήσατε τέτοια κοινή χρήση."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(57),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΛαμβάνουμε σοβαρά υπόψη την προστασία των δεδομένων προσωπικού χαρακτήρα. Έχουμε θέσει σε εφαρμογή φυσικές και τεχνικές εγγυήσεις για τη διατήρηση των πληροφοριών που συλλέγουμε. Ωστόσο, παρακαλούμε να έχετε υπόψη σας ότι παρόλο που λαμβάνουμε εύλογα μέτρα για την προστασία των πληροφοριών σας, καμία ιστοσελίδα, μετάδοση μέσω Διαδικτύου, σύστημα υπολογιστή ή ασύρματη σύνδεση δεν είναι απόλυτα ασφαλής."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(58),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΗ χρήση ή η συμμετοχή σας στις Επιχειρηματικές Υπηρεσίες ενδέχεται να περιλαμβάνει τη διαβίβαση, αποθήκευση και επεξεργασία των στοιχείων σας εκτός της χώρας διαμονής σας, σύμφωνα με την παρούσα πολιτική. Οι εν λόγω χώρες περιλαμβάνουν τη Δημοκρατία της Κορέας. Παρακαλούμε να έχετε υπόψη σας ότι οι νόμοι για την προστασία δεδομένων προσωπικού χαρακτήρα και οι λοιποί νόμοι των χωρών, στις οποίες τα στοιχεία σας ενδέχεται να διαβιβαστούν, μπορεί να μην είναι τόσο πλήρεις όσο αυτοί της χώρας σας. Θα λάβουμε τα κατάλληλα μέτρα, σύμφωνα με την ισχύουσα νομοθεσία, προκειμένου να διασφαλίσουμε ότι τα δεδομένα προσωπικού χαρακτήρα σας παραμένουν προστατευμένα. Τα μέτρα αυτά περιλαμβάνουν τη χρήση τυποποιημένων συμβατικών ρητρών για τη διασφάλιση της διαβίβασης δεδομένων εκτός του ΕΟΧ. Για περισσότερες πληροφορίες σχετικά με τις διασφαλίσεις που λαμβάνουμε για να διασφαλίσουμε τη νόμιμη διαβίβαση των δεδομένων σας σε χώρες εκτός της ΕΕ ή για να λάβετε αντίγραφο των συμβατικών συμφωνιών που ισχύουν, επικοινωνήστε μαζί μας με τις μεθόδους που περιγράφονται στην ενότητα «Επικοινωνήστε μαζί μας» της παρούσας Πολιτικής Προστασίας Προσωπικών Δεδομένων ."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(59),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΤα δεδομένα προσωπικού χαρακτήρα σας ανήκουν σε εσάς. Μπορείτε να μας ζητήσετε να σας δώσουμε λεπτομέρειες σχετικά με αυτά που έχουμε συλλέξει και μπορείτε να μας ζητήσετε να τα διαγράψουμε ή να διορθώσουμε τυχόν ανακρίβειες. Μπορείτε επίσης να μας ζητήσετε να απαγορεύσουμε ή να περιορίσουμε την επεξεργασία, την ανταλλαγή ή τη διαβίβαση των δεδομένων προσωπικού χαρακτήρα σας, καθώς και να σας παρέχουμε τα προσωπικά στοιχεία που έχουμε συλλέξει ώστε να μπορείτε να τα χρησιμοποιήσετε για δικούς σας σκοπούς. Για να ασκήσετε τα δικαιώματά σας, επικοινωνήστε μαζί μας με τις μεθόδους που περιγράφονται στην ενότητα «"
                  ),
                  _c("b", [_vm._v("Επικοινωνίστε Μαζί μας")]),
                  _vm._v(
                    "» της παρούσας Πολιτικής Προστασίας Προσωπικών Δεδομένων. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΩστόσο, η αίτηση διαγραφής των προσωπικών στοιχείων σας μπορεί επίσης να οδηγήσει σε απώλεια πρόσβασης στις Επιχειρηματικές Υπηρεσίες. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΕάν ζητήσετε τη διαγραφή των δεδομένων προσωπικού χαρακτήρα σας, αναγνωρίζετε ότι ενδέχεται να μην μπορείτε να έχετε πρόσβαση ή να χρησιμοποιείτε τις Επιχειρηματικές Υπηρεσίες και ότι τα εναπομείναντα δεδομένα προσωπικού χαρακτήρα ενδέχεται να συνεχίσουν να βρίσκονται αποθηκευμένα σε μητρώα και αρχεία της Samsung για κάποιο χρονικό διάστημα, σύμφωνα μετην εφαρμοστέα νομοθεσία, αλλά η Samsung δεν θα χρησιμοποιήσει αυτά τα στοιχεία για εμπορικούς σκοπούς. Αντιλαμβάνεστε ότι, παρά το αίτημα σας για διαγραφή, η Samsung έχει το δικαίωμα να διατηρήσει τα δεδομένα προσωπικού χαρακτήρα σας ή ένα μέρος τους, σύμφωνα με την πολιτική μας για την διατήρηση δεδομένων και την εφαρμοστέα νομοθεσία, σε περίπτωση κατά την οποία η Samsung έχει αναστείλει, περιορίσει ή τερματίσει την πρόσβασή σας στην ιστοσελίδα λόγω παραβίασης των Όρων Χρήσης της Samsung ή κάθε άλλης τυχόν εφαρμοστέας πολιτικής της Samsung ή εφαρμοστέας νομοθεσίας, όταν είναι απαραίτητο για την προστασία των δικαιωμάτων, της ιδιοκτησίας ή της ασφάλειας της Samsung ή οποιασδήποτε από τις αντίστοιχες συνδεδεμένες εταιρείες μας, τους επιχειρηματικούς συνεργάτες, τους υπαλλήλους, ή τους πελάτες μας."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(60),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΔεν θα διατηρήσουμε τα δεδομένα προσωπικού χαρακτήρα σας για περισσότερο από όσο είναι απαραίτητο για το σκοπό που συλλέχθηκαν. Αυτό σημαίνει ότι τα στοιχεία σας θα καταστραφούν ή θα διαγραφούν από τα συστήματά μας όταν δεν είναι πλέον απαραίτητα."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΛαμβάνουμε τα κατάλληλα μέτρα για να διασφαλίσουμε ότι επεξεργαζόμαστε και διατηρούμε πληροφορίες σχετικά με εσάς με βάση την ακόλουθη λογική:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n1. Τουλάχιστον τη διάρκεια για την οποία χρησιμοποιούνται οι πληροφορίες για την παροχή μιας υπηρεσίας. "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n2. Όπως απαιτείται από τον νόμο, από μια σύμβαση ή από τις νόμιμες υποχρεώσεις μας."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n3. Μόνο για όσο χρονικό διάστημα είναι αναγκαίο για το σκοπό για τον οποίο συλλέχθηκαν ή επεξεργάστηκαν ή για μεγαλύτερο χρονικό διάστημα, εάν αυτό απαιτείται βάσει οποιασδήποτε σύμβασης, εφαρμοστέου δικαίου ή για στατιστικούς σκοπούς, με την επιφύλαξη των κατάλληλων διασφαλίσεων."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(61),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΣας προσφέρουμε ορισμένες επιλογές σε σχέση με τα δεδομένα προσωπικού χαρακτήρα που λαμβάνουμε για εσάς.  "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΟι Επιχειρηματικές Υπηρεσίες μπορούν να προσφέρουν επιλογές που σχετίζονται με τη συλλογή, τη διαγραφή και την ανταλλαγή ορισμένων πληροφοριών που σχετίζονται με τις Επιχειρηματικές Υπηρεσίες. Εάν αρνηθείτε να επιτρέψετε στις Επιχειρηματικές Υπηρεσίες να συλλέγουν, να αποθηκεύουν ή να διαμοιράζονται ορισμένες πληροφορίες, ενδέχεται να μην μπορείτε να χρησιμοποιήσετε όλες τις λειτουργίες διαθέσιμες μέσω των Επιχειρηματικών Υπηρεσιών."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΓια να εφαρμόσετε τις επιλογές σας, επικοινωνήστε μαζί μας όπως υποδεικνύεται στην ενότητα «"
                  ),
                  _c("b", [_vm._v("Επικοινωνήστε μαζί μας")]),
                  _vm._v(
                    "» της παρούσας Πολιτικής Προστασίας Προσωπικών Δεδομένων.  "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(62),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΜπορείτε να επικοινωνήσετε μαζί μας για να επικαιροποιήσετε τις προτιμήσεις σας, να διορθώσετε τα στοιχεία σας, να υποβάλετε ένα αίτημα ή να μας κάνετε ερωτήσεις."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΜπορείτε να επικοινωνήσετε μαζί μας στη διεύθυνση:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nData Controller"),
                  _c("br"),
                  _vm._v("\nSamsung Electronics Co., Ltd."),
                  _c("br"),
                  _vm._v("\n129, Samsung-ro, Yeongtong-gu,"),
                  _c("br"),
                  _vm._v("\nSuwon-si, Gyeonggi-do 16677, Republic of Korea"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΗ Samsung Electronics έχει γραφεία σε ολόκληρη την Ευρώπη, ώστε να μπορούμε να εξασφαλίσουμε ότι το αίτημα ή το ερώτημά σας αποτελεί αντικείμενο επεξεργασίας από την ομάδα προστασίας δεδομένων που εδρεύει στην περιοχή σας."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΟ ευκολότερος τρόπος να επικοινωνήσετε μαζί μας είναι μέσω της Σελίδας Υποστήριξης Προστασίας Προσωπικών Δεδομένων στο "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.samsung.com/request-desk",
                        target: "_blank"
                      }
                    },
                    [_vm._v("https://www.samsung.com/request-desk")]
                  ),
                  _vm._v(". "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΜπορείτε επίσης να επικοινωνήσετε μαζί μας στη διεύθυνση:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nΥπεύθυνος προστασίας δεδομένων για την Ευρώπη"),
                  _c("br"),
                  _vm._v("\nSamsung Electronics (UK) Limited"),
                  _c("br"),
                  _vm._v(
                    "\nSamsung House, 1000 Hillswood Drive, Chertsey, Surrey KT16 0PS"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nΜπορείτε να υποβάλετε καταγγελία στην αρμόδια εποπτική αρχή εάν θεωρήσετε ότι η επεξεργασία των προσωπικών σας στοιχείων παραβιάζει την εφαρμοστέα νομοθεσία. Τα στοιχεία επικοινωνίας για όλες τις εποπτικές αρχές της ΕΕ διατίθενται στη διεύθυνση  "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080",
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v(
                        "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080"
                      )
                    ]
                  ),
                  _vm._v(".\n                        ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.languageCd == "cs"
              ? _c("div", { staticClass: "terms-detail" }, [
                  _vm._v("\nÚčinnost: 1. ledna 2021"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nSamsung Electronics Co., Ltd. (Správce údajů) („"),
                  _c("b", [_vm._v("Samsung")]),
                  _vm._v(
                    "“) si je vědom, jak je soukromí důležité pro její zákazníky a její zaměstnance a partnery, proto se snažíme být transparentní ohledně toho, jak shromažďujeme, užíváme, sdělujeme, předáváme a ukládáme Vaše údaje. Tyto Zásady ochrany soukromí poskytují přehled našeho nakládání s informacemi ve vztahu k osobním údajům získaným skrze službu Service Knowledge Portál od komerčních zákazníků  („"
                  ),
                  _c("b", [_vm._v("Podnikatelské Služby")]),
                  _vm._v("“)."),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nTyto Zásady ochrany soukromí mohou být pravidelně aktualizovány tak, aby reflektovaly naše změny v nakládání s informacemi v souvislosti s Podnikatelskými Službami nebo změny v rozhodném právu. V úvodu těchto Zásad ochrany soukromí bude uvedeno, kdy byly naposledy aktualizovány. Pokud Zásady ochrany soukromí aktualizujeme, budeme Vás o změnách, které považujeme za zásadní, informovat tak, že umístíme upozornění do Podnikatelské Služby nebo Vám je ve vhodných případech zašleme e-mailem."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(63),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nBudeme shromažďovat různé typy osobních údajů vztahujících se k Podnikatelským Službám,"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nzejména: "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tBudeme shromažďovat osobní údaje, které nám poskytnete, zejména Vaše jméno a příjmení, e-mailovou adresu a případně další kontaktní údaje, a jakoukoliv komunikaci, kterou nám zašlete nebo doručíte;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tBudeme shromažďovat informace o službách, které jste Vy nebo Váš zaměstnavatel obdrželi a další informace poskytnuté v souvislosti s Podnikatelskými Službami, například informace shromážděné v souvislosti s poskytnutím servisních služeb, včetně toho, jaký produkt byl přidělen subjektu údajů, zda to daný systém odsouhlasil, jaká je celková historie a datum, kdy systém obdržel žádost od uživatelů; a"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tTaktéž můžeme obdržet osobní údaje o Vás či od Vašeho zaměstnavatele nebo poskytovatele služeb nebo z veřejně a komerčně dostupných zdrojů (v souladu se zákonem), které můžeme sloučit s ostatními informacemi, které obdržíme od Vás nebo o Vás (v souladu se zákonem). "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(64),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nZískané údaje můžeme používat k následujícím účelům:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tK poskytnutí služeb, které jste si Vy (nebo Váš zaměstnavatel) vyžádali a k registraci nebo ověření Vás a Vaší společnosti;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tK zodpovězení Vašich dotazů nebo žádostí o informace;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tK nabídce lepších služeb, které berou v potaz záznamy služeb poskytnutých Vaší společnosti a další relevantní informace;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tk informování o nových produktech a službách a to na základě Vašeho zvláštního souhlasu v případě, že je vyžadován rozhodným právem;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tk posouzení a analýze našeho trhu, zákazníků, výrobků a služeb (včetně získávání Vašich názorů na naše výrobky a služby a provádění průzkumů zákazníků);"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tk pochopení toho, jak společnosti využívají Podnikatelské Služby k tomu, abychom je mohli zlepšit a vyvinout nové výrobky a služby;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tk provedení technické údržby a k udržení dostatečné úrovně zabezpečení našich Podnikatelských Služeb;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tk ochraně práv, majetku, nebo bezpečnosti společnosti Samsung, nebo jakékoli příslušné spřízněné osoby, obchodního partnera, zaměstnance nebo zákazníka, například v soudním řízení, interním vyšetřování a vyšetřování vedeném příslušnými orgány;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tjinak na základě Vašeho zvláštního souhlasu, pokud je vyžadován zákonem, nebo jak bylo dohodnuto v době shromáždění Vašich údajů. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSamsung zpracovává osobní údaje k výše uvedeným účelům. Právní základ, na základě kterého Samsung zpracovává osobní údaje, zahrnuje zpracování:"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(i)\tk tomu, abychom mohli dodržet naše přísliby, jako je Vám poskytnout Podnikatelské Služby;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(ii)\tk prosazování našich podnikatelských zájmů (například, ke správě našeho vztahu s Vámi); a"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(iii)\tke splnění zákonných předpokladů a předpokladů v jiných právních předpisech;"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(65),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVaše údaje si budeme interně poskytovat v rámci našeho podnikání, ale pouze těm, kteří je potřebují k poskytování Služeb nebo k řešení Vašich požadavků. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVaše údaje budeme také poskytovat následujícím subjektům, a to pouze v rozsahu, v jakém to bude nezbytné pro poskytování Podnikatelských služeb:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tSpřízněné osoby: jiné společnosti skupiny Samsung Electronics, které kontrolujeme nebo vlastníme."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tDalším stranám, pokud je to vyžadováno zákonem nebo nezbytné k ochraně našeho podnikání: například, může to být nezbytné na základě zákona, soudního řízení, nebo z příkazu vládních orgánů sdělit Vaše údaje. V těchto případech mohou požadovat Vaše údaje také v souvislosti s výkonem rozhodnutí, národní bezpečností, opatřeními proti terorismu, nebo s dalšími okolnostmi, které se vztahují k veřejné bezpečnosti. "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tDalším stranám v souvislosti s korporátními transakcemi: Můžeme sdělit Vaše údaje třetí straně jakožto součást spojování nebo převodu, akvizice nebo prodeje, nebo v případě úpadku. "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tDalším stranám na základě Vašeho souhlasu nebo na Váš pokyn: Kromě sdělování údajů v souladu se Zásadami ochrany soukromí, můžeme sdílet Vaše informace se třetími stranami na základě Vašeho zvláštního souhlasu nebo na základě Vaší žádosti tyto údaje sdělit. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(66),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nOtázku zabezpečení údajů bereme vážně. Přijali jsme fyzické i technické záruky k tomu, abychom zajistili bezpečnost shromážděných údajů. Nicméně, vezměte prosím na vědomí, že ačkoliv podnikáme rozumné kroky k ochraně Vašich informací, žádná webová stránka, internetový přenos, počítačový systém, nebo bezdrátové připojení nejsou naprosto bezpečné.\n"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(67),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVaše použití nebo účast na Podnikatelských Službách může zahrnovat předání, uložení a zpracování Vašich údajů mimo zemi Vašeho bydliště, a to v souladu s těmito zásadami. Tyto země zahrnují Korejskou republiku. Prosím vezměte na vědomí, že ochrana osobních údajů a další právní normy zemí, kam mohou být Vaše údaje předány, nemusejí být tak komplexní jako ve Vaší zemi. V souladu s rozhodným právem přijmeme příslušná opatření, abychom zajistili, že Vaše osobní údaje zůstanou chráněny. Tato opatření zahrnují použití Všeobecných obchodních podmínek k zajištění předání údajů mimo EHP (EEA). Pro více informací o zárukách, které jsme přijali k zajištění zákonného předání Vašich osobních údajů mimo EU, nebo k získání kopií účinných smluvních dohod, nás prosím kontaktujte způsobem uvedeným v sekci Kontaktujte nás těchto Zásad ochrany soukromí. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(68),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVaše osobní údaje vlastníte vy. Můžete nás požádat o poskytnutí detailů ohledně toho, jaké údaje jsme o Vás nashromáždili a můžete nás požádat o jejich smazání nebo o opravu jejich nepřesností. Můžete nás také požádat o přístup k Vašim osobním údajům, jejich přenesení, omezení nebo limitování zpracování, sdílení nebo předání Vašich osobních údajů, stejně tak o poskytnutí Vašich osobních údajů, které jsme o Vás shromáždili, abyste je mohli využít pro své vlastní účely. Pro výkon těchto svých práv nás prosím kontaktujte způsobem uvedeným v sekci "
                  ),
                  _c("b", [_vm._v("Kontaktujte nás")]),
                  _vm._v(
                    " těchto Zásad ochrany soukromí. Dále máte právo vznést námitku, popř. stížnost proti zpracování osobních údajů na Úřad pro ochranu osobních údajů. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNicméně, žádost o výmaz Vašich osobních údajů může vést ke ztrátě přístupu k Podnikatelským Službám "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nV případě, že si požádáte o výmaz Vašich osobních údajů, tak berete na vědomí, že nemusíte mít přístup a být schopni využít Podnikatelské Služby a že zbylé osobní údaje mohou zůstat v evidenci a archivech společnosti Samsung a to po dobu, kterou předvídá rozhodné právo. Společnost Samsung však tyto osobní údaje nevyužije pro komerční účely. Jste srozuměni s tím, že bez ohledu na Vaši žádost o výmaz si společnost Samsung vyhrazuje právo uchovat Vaše osobní údaje, nebo jejich relevantní část, v souladu s našimi zásadami o retenci dat a rozhodným právem, pokud společnost Samsung pozastavila, omezila nebo zrušila Váš přístup na webovou stránku z důvodu porušení Všeobecných obchodních podmínek společnosti Samsung nebo jakékoliv části zásad společnosti Samsung nebo rozhodného práva, v případě, že je to nutné pro ochranu práv, vlastnictví, nebo bezpečnosti společnosti Samsung, nebo jakékoli naší spřízněné osoby, obchodního partnera, zaměstnanců nebo zákazníků. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(69),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVaše osobní údaje neuchováváme po dobu delší, než je nezbytně nutné pro účely, pro které byly shromážděny. To znamená, že osobní údaje budou zničeny nebo smazány z našich systémů, když již nebudou dále potřebné. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nČiníme potřebné kroky k zajištění toho, že zpracováváme a držíme údaje o Vás na základě následující logiky:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n1.\tNejkratší doba, po kterou jsou využívány Vaše údaje, je doba, po kterou Vám poskytujeme službu;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n2.\tTak, jak je vyžadováno na základě zákona, smlouvy, nebo v souladu s našimi zákonnými povinnostmi;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n3.\tJen tak dlouho, jak je to nezbytné pro účel, pro který byly shromážděny, zpracovány, nebo déle, pokud je to vyžadováno na základě jakékoli smlouvy, rozhodného práva, nebo pro statistické účely, s výhradou vhodných ochranných opatření. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(70),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNabízíme Vám určité volby ve vztahu k osobním údajům, které o Vás obdržíme. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "  \nPodnikatelské Služby mohou nabízet různé volby vztahující se ke shromažďování, výmazu a sdílení určitých údajů souvisejících s Podnikatelskými Službami. V případě, že odmítnete povolit Podnikatelským Službám sběr, uložení nebo sdílení určitých informací, pak je možné, že nebudete moci plně využít Podnikatelské Služby.  "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "  \nK provedení Vašich voleb, nás prosím kontaktujte způsobem uvedeným v sekci "
                  ),
                  _c("b", [_vm._v("Kontaktujte nás ")]),
                  _vm._v(" těchto Zásad ochrany soukromí. "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(71),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nMůžete nás kontaktovat za účelem aktualizace Vašich preferencí, opravy Vašich údajů, podání žádostí, nebo položení dotazů. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nMůžete nás kontaktovat na adrese:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nData Controller"),
                  _c("br"),
                  _vm._v("\nSamsung Electronics Co., Ltd."),
                  _c("br"),
                  _vm._v("\n129, Samsung-ro, Yeongtong-gu,"),
                  _c("br"),
                  _vm._v("\nSuwon-si, Gyeonggi-do 16677, Korejská republika"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSamsung Electronics má kanceláře napříč Evropou, takže Vám můžeme zaručit, že Váš dotaz nebo Vaše žádost bude řešena týmem zabývajícím se ochranou osobních údajů ve Vašem regionu. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNejjednodušším způsobem, jak nás kontaktovat je skrze naši „Privacy Support Page“ na adrese:  "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.samsung.com/request-desk",
                        target: "_blank"
                      }
                    },
                    [_vm._v("https://www.samsung.com/request-desk")]
                  ),
                  _vm._v(". "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nMůžete nás také kontaktovat na adrese:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nEuropean Data Protection Officer"),
                  _c("br"),
                  _vm._v("\nSamsung Electronics (UK) Limited"),
                  _c("br"),
                  _vm._v(
                    "\nSamsung House, 1000 Hillswood Drive, Chertsey, Surrey KT16 0PS"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nKromě toho můžete podat stížnost u příslušného dozorového úřadu, pokud naznáte, že naše zpracování Vašich osobních údajů je v rozporu s rozhodným právem. Kontaktní údaje o všech dozorových úřadech můžete nalézt na "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080",
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v(
                        "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080"
                      )
                    ]
                  ),
                  _vm._v("."),
                  _c("br"),
                  _vm._v(
                    "\nPro Českou republiku je příslušný Úřad pro ochranu osobních údajů ČR, Pplk. Sochora 27, 170 00 Praha 7.\n                        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.languageCd == "sk"
              ? _c("div", { staticClass: "terms-detail" }, [
                  _vm._v("\nÚčinnosť: 1. januára 2021"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v('\nSamsung Electronics Co., Ltd. (Správca údajov) ("'),
                  _c("b", [_vm._v("Samsung")]),
                  _vm._v(
                    '")si je vedomá dôležitosti súkromia pre svojich zákazníkov a jej zamestnancov a partnerov, preto sa snažíme byť transparentní, pokiaľ ide o to, ako zhromažďujeme, používame, zverejňujeme, prenášame a uchovávame Vaše údaje. Tieto Zásady ochrany súkromia poskytujú prehľad nášho nakladania s informáciami týkajúcimi sa osobných údajov zhromaždených prostredníctvom služby Service Knowledge Portál od komerčných zákazníkov („'
                  ),
                  _c("b", [_vm._v("Podnikateľské Služby")]),
                  _vm._v('").'),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nTieto Zásady ochrany súkromia sa môžu pravidelne aktualizovať tak, aby odrážali naše zmeny v nakladaní s informáciami v súvislosti s Podnikateľskými Službami alebo zmeny v platných právnych predpisoch. V úvode týchto Zásad ochrany súkromia sa uvedie, kedy boli naposledy aktualizované. Ak aktualizujeme Zásady ochrany súkromia, budeme Vás informovať o zmenách, ktoré považujeme za zásadné, a to umiestnením upozornenia do Podnikateľskej Služby alebo Vám ich vo vhodných prípadoch pošleme e-mailom."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(72),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nBudeme zhromažďovať rôzne typy osobných údajov súvisiacich s Podnikateľskými Službami."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nNajmä:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tBudeme zhromažďovať osobné údaje, ktoré nám poskytnete, najmä vaše meno, priezvisko, e-mailovú adresu a prípadne ďalšie kontaktné údaje a akékoľvek komunikácie, ktoré nám odošlete alebo doručíte;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tBudeme zhromažďovať informácie o službách, ktoré ste Vy alebo Váš zamestnávateľ prijali a ďalšie informácie poskytnuté v súvislosti s Podnikateľskými Službami, napríklad informácie zhromaždené v súvislosti s poskytovaním servisných služieb, vrátane toho, aký produkt bol pridelený subjektu údajov, či to daný systém odsúhlasil, aká je celková história a dátum, kedy systém dostal žiadosť od používateľov; a"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n\n•\tOsobné údaje o Vás môžeme získať aj od Vášho zamestnávateľa alebo poskytovateľa služieb alebo z verejne a komerčne dostupných zdrojov (v súlade so zákonom), ktoré môžeme zlúčiť s ostatnými informáciami, ktoré od Vás alebo o Vás dostávame (v súlade so zákonom). "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(73),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nZískané údaje môžeme používať na nasledujúce účely:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tNa poskytovanie služieb, ktoré ste požadovali Vy (alebo Váš zamestnávateľ) a registráciu alebo overenie Vás a Vašej spoločnosti;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tNa zodpovedanie Vašich otázok alebo žiadostí o informácie;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tZa účelom ponuky lepších služieb, ktoré zohľadňujú záznamy o službách poskytovaných Vašej spoločnosti a ďalšie relevantné informácie;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tNa informovanie o nových produktoch a službách, a to na základe Vášho konkrétneho súhlasu, ak to vyžadujú platné právne predpisy;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tNa hodnotenie a analýzu nášho trhu, zákazníkov, produktov a služieb (vrátane získavania Vašich názorov na naše produkty a služby a vykonávanie zákazníckych prieskumov);"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tNa pochopenie toho, ako spoločnosti využívajú Podnikateľské Služby na to, aby sme ich mohli zlepšiť a vyvinúť nové produkty a služby;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tNa výkon technickej údržby a udržanie dostatočnej úrovne zabezpečenia našich Podnikateľských Služieb;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tNa ochranu práv, majetku alebo bezpečnosti spoločnosti Samsung alebo akejkoľvek príslušnej spriaznenej strany, obchodného partnera, zamestnanca alebo zákazníka, napríklad v súdnych konaniach, interných vyšetrovaniach a vyšetrovaniach vedených príslušnými orgánmi;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tInak na základe Vášho osobitného súhlasu, ak to vyžaduje zákon alebo ak to bolo dohodnuté v dobe zhromažďovania Vašich údajov. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSpoločnosť Samsung spracúva osobné údaje na vyššie uvedené účely. Právny základ, na základe ktorého spoločnosť Samsung spracúva osobné údaje, zahŕňa spracovanie:"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(i)\tZa účelom dodržiavania našich prísľubov, ako je poskytovanie Podnikateľských Služieb;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(ii)\tZa účelom presadzovania našich podnikateľských záujmov (napríklad k správe nášho vzťahu s Vami); a"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n(iii)\tZa účelom splnenia zákonných predpokladov a predpokladov v iných právnych predpisoch."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(74),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVaše údaje budeme poskytovať interne v rámci nášho podnikania, ale len tým, ktorí ich potrebujú na poskytovanie služieb alebo na riešenie Vašich požiadaviek. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVaše údaje budeme poskytovať aj nasledujúcim subjektom, a to v rozsahu, v akom to bude nevyhnutné na poskytovanie Podnikateľských Služieb:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n•\tSpriazneným osobám: iné spoločnosti skupiny Samsung Electronics Group, ktoré ovládame alebo vlastníme."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tĎalším stranám, ak to vyžaduje zákon alebo je to potrebné na ochranu nášho podnikania: napríklad môže byť potrebné zverejniť Vaše údaje na základe zákona, súdneho konania alebo na príkaz vládnych orgánov. V týchto prípadoch môžu byť požadované Vaše údaje taktiež v súvislosti s výkonom rozhodnutí, národnou bezpečnosťou, protiteroristickými opatreniami alebo ďalšími okolnosťami týkajúcimi sa verejnej bezpečnosti. "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tĎalším stranám v súvislosti s korporátnymi transakciami: Vaše informácie môžeme poskytnúť tretej strane ako súčasť zlúčenia alebo prevodu, akvizície alebo predaja alebo v prípade konkurzu. "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n•\tĎalším stranám na základe Vášho súhlasu alebo na Váš pokyn: Okrem zverejňovania údajov v súlade so Zásadami ochrany súkromia môžeme Vaše údaje zdieľať s tretími stranami na základe Vášho osobitného súhlasu alebo na základe Vašej žiadosti o zverejnenie takýchto údajov. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(75),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nOtázku bezpečnosti údajov berieme vážne. Prijali sme fyzické aj technické záruky na zaistenie bezpečnosti zhromaždených údajov. Upozorňujeme však, že aj keď podnikáme primerané kroky na ochranu Vašich informácií, žiadna webová stránka, internetový prenos, počítačový systém alebo bezdrôtové pripojenie nie sú úplne bezpečné. \n"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(76),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVaše používanie alebo účasť na Podnikateľských Službách môže zahŕňať odovzdávanie, uchovávanie a spracovanie Vašich údajov mimo krajinu Vášho bydliska v súlade s týmito zásadami. Medzi tieto krajiny patrí Kórejská republika. Upozorňujeme, že ochrana osobných údajov a iných právnych noriem krajín, do ktorých môžu byť Vaše údaje odovzdané, nemusí byť tak komplexná ako vo Vašej krajine. V súlade s platnými právnymi predpismi prijmeme vhodné opatrenia na zabezpečenie toho, aby Vaše osobné údaje zostali naďalej chránené. Tieto opatrenia zahŕňajú použitie Všeobecných obchodných podmienok na zabezpečenie odovzdania údajov mimo EHP. Ak chcete získať ďalšie informácie o zárukách, ktoré sme realizovali na zabezpečenie zákonného odovzdania Vašich osobných údajov mimo EÚ alebo na získanie kópií účinných zmluvných dohôd, prosím kontaktujte nás, ako je uvedené v sekcii Kontaktujte nás týchto Zásad ochrany súkromia. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(77),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVaše osobné údaje vlastníte Vy. Môžete nás požiadať o poskytnutie podrobností o tom, aké údaje sme o Vás zhromaždili a môžete nás požiadať, aby sme ich odstránili alebo opravili ich nepresnosti. Môžete nás požiadať o prístup k svojim osobným údajom. Môžete nás tiež požiadať o obmedzenie alebo limitáciu spracovania, zdieľania alebo prenosu Vašich osobných údajov, ako aj o poskytnutie Vašich osobných údajov, ktoré sme o Vás zhromaždili, aby ste ich mohli použiť na svoje vlastné účely. Pre výkon týchto svojich práv nás prosím kontaktujte, a to spôsobom, ktorý je uvedený v sekcii Kontaktujte nás týchto Zásad ochrany súkromia. Máte právo namietať spracúvanie osobných údajov a právo na prenosnosť osobných údajov. "
                  ),
                  _c("br"),
                  _vm._v(
                    "\nMáte právo podať návrh na začatie konania o ochrane osobných údajov na Úrade na ochranu osobných údajov Slovenskej republiky."
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nŽiadosť o vymazanie Vašich osobných údajov môže ale mať za následok stratu prístupu k Podnikateľských Službám. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nV prípade, že požiadate o vymazanie Vašich osobných údajov, beriete na vedomie, že nemusíte mať prístup a byť schopní využiť Podnikateľské Služby a že zostávajúce osobné údaje môžu zostať v záznamoch a archívoch spoločnosti Samsung tak dlho, ako to predpokladajú platné právne predpisy. Spoločnosť Samsung však nebude používať tieto osobné údaje na komerčné účely. Beriete na vedomie, že bez ohľadu na Vašu žiadosť o vymazanie si spoločnosť Samsung vyhradzuje právo uchovávať Vaše osobné údaje alebo ich relevantnú časť v súlade s našimi pravidlami uchovávania údajov a platnými právnymi predpismi, ak spoločnosť Samsung pozastavila, obmedzila alebo zrušila Váš prístup na webovú stránku z dôvodu porušenia Všeobecných obchodných podmienok spoločnosti Samsung alebo akejkoľvek časti zásad spoločnosti Samsung alebo platných právnych predpisov, v prípade, že je to potrebné na ochranu práv, vlastníctva alebo bezpečnosti spoločnosti Samsung alebo ktorejkoľvek z našich spriaznených osôb, obchodných partnerov, zamestnancov alebo zákazníkov. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(78),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nVaše osobné údaje neukladáme dlhšie, ako je nevyhnutne potrebné na účely, na ktoré boli zhromaždené. To znamená, že osobné údaje budú zničené alebo vymazané z našich systémov, keď už nebudú potrebné. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nPodnikáme potrebné kroky na zabezpečenie toho, aby sme spracúvali a držali údaje o Vás na základe nasledujúcej logiky:"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n1.\tNajkratšia doba, na ktorú sa Vaše údaje využívajú, je doba, počas ktorej Vám poskytujeme službu;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n2.\tTak, ako to vyžaduje zákon, zmluva, alebo v súlade s našimi zákonnými povinnosťami;"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n3.\tIba tak dlho, ako je to nevyhnutné na účel, na ktorý boli zhromaždené, spracované alebo dlhšie, ak sa to vyžaduje na základe akejkoľvek zmluvy, rozhodného práva alebo na štatistické účely, s výhradou primeraných ochranných opatrení. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(79),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nPonúkame Vám určité možnosti týkajúce sa osobných údajov, ktoré o Vás dostávame. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "  \nPodnikateľské Služby môžu ponúkať rôzne možnosti súvisiace so zhromažďovaním, odstraňovaním a zdieľaním určitých údajov súvisiacich s Podnikateľskými Službami. Ak odmietnete povoliť Podnikateľským Službám zhromažďovať, ukladať alebo zdieľať určité informácie, potom možno nebudete môcť v plnej miere využívať Podnikateľské Služby. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "  \nZa účelom uplatnenia Vašich možností nás prosím kontaktujte spôsobom špecifikovaným v sekcii "
                  ),
                  _c("b", [_vm._v("Kontaktujte nás")]),
                  _vm._v(" týchto Zásad ochrany súkromia. "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(80),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nMôžete nás kontaktovať za účelom aktualizácie Vašich preferencií, opravy Vašich údajov, predloženia žiadostí alebo položenia otázok. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nMôžete nás kontaktovať na adrese:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nData Controller"),
                  _c("br"),
                  _vm._v("\nSamsung Electronics Co., Ltd."),
                  _c("br"),
                  _vm._v("\n129, Samsung-ro, Yeongtong-gu,"),
                  _c("br"),
                  _vm._v("\nSuwon-si, Gyeonggi-do 16677, Korejská republika"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nSpoločnosť Samsung Electronics má kancelárie naprieč Európou, takže Vám môžeme zaručiť, že Vašou otázkou alebo Vašou žiadosťou sa bude zaoberať tím špecializujúci sa na ochranu údajov vo Vašom regióne. "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nNajjednoduchší spôsob, ako nás kontaktovať, je prostredníctvom našej „Privacy Support Page“ na adrese:  "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.samsung.com/request-desk",
                        target: "_blank"
                      }
                    },
                    [_vm._v("https://www.europe-samsung.com/gdpr/webform/sk")]
                  ),
                  _vm._v(".  "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nMôžete nás tiež kontaktovať na:"),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\nEuropean Data Protection Officer"),
                  _c("br"),
                  _vm._v("\nSamsung Electronics (UK) Limited"),
                  _c("br"),
                  _vm._v(
                    "\nSamsung House, 1000 Hillswood Drive, Chertsey, Surrey KT16 0PS"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\nOkrem toho môžete podať sťažnosť príslušnému dozornému orgánu, ak sa domnievate, že naše spracovanie Vašich osobných údajov je v rozpore s platnými právnymi predpismi. Kontaktné údaje všetkých dozorných orgánov možno nájsť na  "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080",
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v(
                        "https://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080"
                      )
                    ]
                  ),
                  _vm._v(".\n"),
                  _c("br"),
                  _vm._v(
                    "\nPre Slovenskú republiku je príslušným Úrad na ochranu osobných údajov Slovenskej republiky.\n                        "
                  )
                ])
              : _vm._e()
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("What information do we collect?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("How do we use your information?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("To whom do we disclose your information?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("How do we keep your information secure?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Where do we send your data?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("What are your rights?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("How long do we keep your information?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Your Choices")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Contact Us")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Les informations que nous recueillons")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("La manière dont nous utilisons vos informations ?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [
        _vm._v("Les personnes auxquelles nous divulguons vos informations ?")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [
        _vm._v("Comment conservons-nous vos informations en toute sécurité ?")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Où envoyons-nous vos données ?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Quels sont vos droits ?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Durée de conservation de vos informations ?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Vos choix")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Nous contacter")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Welche Daten erfassen wir?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Wie verwenden wir Ihre Daten?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("An wen geben wir Ihre Daten weiter?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Wie bewahren wir Ihre Daten sicher auf?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Wohin senden wir Ihre Daten?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Welche Rechte haben Sie?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Wie lange bewahren wir Ihre Daten auf?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Ihre Optionen")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Kontakt")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Che informazioni raccogliamo?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Come utilizziamo i tuoi dati?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Con chi possiamo condividere i tuoi dati?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Come proteggiamo i tuoi dati?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Dove mandiamo i tuoi dati?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Quali sono i tuoi diritti?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Per quanto tempo conserviamo i tuoi dati?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Le tue scelte")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Contattaci")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Que informações recolhemos?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Como utilizamos os dados do utilizador?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("A quem divulgamos os dados pessoais do utilizador?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [
        _vm._v("Como mantemos seguros os Dados Pessoais do utilizador?")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Para onde enviamos os dados do utilizador?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Quais são os direitos do utilizador?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [
        _vm._v(
          "Durante quanto tempo guardamos os Dados Pessoais do utilizador?"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Escolhas do utilizador")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Contacte-nos")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("¿Qué información recopilamos?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("¿Cómo utilizamos su información?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("¿Con quién compartimos su información?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("¿Cómo garantizamos la seguridad de su información?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("¿Dónde enviamos sus datos?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("¿Cuáles son sus derechos?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("¿Durante cuánto tiempo conservamos su información?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Usted elige")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Contacte con nosotros")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Τι είδους πληροφορίες συλλέγουμε;")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Πώς χρησιμοποιούμε τις πληροφορίες σας;")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Σε ποιον γνωστοποιούμε τα στοιχεία σας;")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Πως θα κρατήσουμε ασφαλή τα στοιχεία σας;")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Πού στέλνουμε τα δεδομένα σας;")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Ποιά είναι τα δικαιώματα σας;")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [
        _vm._v("Πόσο καιρό θα κρατήσουμε αποθηκευμένες τις πληροφορίες σας;")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Οι Επιλογές σας")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Επικοινωνήστε μαζί μας")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Jaké údaje shromažďujeme?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Jak a proč Vaše údaje používáme?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Komu poskytujeme Vaše údaje?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Jak zajišťujeme zabezpečení Vašich údajů?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Kam Vaše údaje posíláme?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Jaká jsou Vaše práva?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Jak dlouho uchováváme Vaše údaje?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Vaše Volby")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Kontaktujte nás")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Aké údaje zhromažďujeme?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Ako a na aké účely používame Vaše údaje?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Komu poskytujeme Vaše údaje?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [
      _c("u", [_vm._v("Ako zaisťujeme bezpečnosť Vašich údajov?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Kam posielame Vaše údaje?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Aké sú Vaše práva?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Ako dlho uchovávame Vaše údaje?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Vaše možnosti")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("u", [_vm._v("Kontaktujte nás")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1258ff7f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1258ff7f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/eur/user/AgreeViewPrivacyPolicy.vue
// module id = x5nB
// module chunks = 0